{
  "about.blocks": "Modererade servrar",
  "about.contact": "Kontakt:",
  "about.default_locale": "Standard",
  "about.disclaimer": "Mastodon är fri programvara med öppen källkod och ett varumärke som tillhör Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Okänd orsak",
  "about.domain_blocks.preamble": "Som regel låter Mastodon dig interagera med användare från andra servrar i fediversumet och se deras innehåll. Detta är de undantag som gjorts på just denna server.",
  "about.domain_blocks.silenced.explanation": "Såvida du inte uttryckligen söker upp dem eller samtycker till att se dem genom att följa dem kommer du i allmänhet inte se profiler från den här servern, eller deras innehåll.",
  "about.domain_blocks.silenced.title": "Begränsat",
  "about.domain_blocks.suspended.explanation": "Inga data från denna server kommer behandlas, lagras eller bytas ut, vilket omöjliggör kommunikation med användare på denna server.",
  "about.domain_blocks.suspended.title": "Avstängd",
  "about.language_label": "Språk",
  "about.not_available": "Denna information har inte gjorts tillgänglig på denna server.",
  "about.powered_by": "En decentraliserad plattform for sociala medier, drivet av {mastodon}",
  "about.rules": "Serverregler",
  "account.account_note_header": "Personlig anteckning",
  "account.activity": "Aktivitet",
  "account.add_note": "Lägg till en personlig anteckning",
  "account.add_or_remove_from_list": "Lägg till i eller ta bort från listor",
  "account.badges.admin": "Administratör",
  "account.badges.blocked": "Blockerad",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Blockerad domän",
  "account.badges.group": "Grupp",
  "account.badges.muted": "Tystad",
  "account.badges.muted_until": "Tystade till {until}",
  "account.block": "Blockera @{name}",
  "account.block_domain": "Blockera domänen {domain}",
  "account.block_short": "Blockera",
  "account.blocked": "Blockerad",
  "account.cancel_follow_request": "Återkalla din begäran om att få följa",
  "account.copy": "Kopiera länk till profil",
  "account.direct": "Nämn @{name} privat",
  "account.disable_notifications": "Sluta meddela mig när @{name} skriver ett inlägg",
  "account.edit_note": "Redigera personlig anteckning",
  "account.edit_profile": "Redigera profil",
  "account.edit_profile_short": "Redigera",
  "account.enable_notifications": "Notifiera mig när @{name} gör inlägg",
  "account.endorse": "Visa på profil",
  "account.familiar_followers_many": "Följs av {name1},{name2} och {othersCount, plural, one {en till du känner} other {# andra du känner}}",
  "account.familiar_followers_one": "Följs av {name1}",
  "account.familiar_followers_two": "Följs av {name1} och {name2}",
  "account.featured": "Utvalda",
  "account.featured.accounts": "Profiler",
  "account.featured.collections": "Samlingar",
  "account.featured.new_collection": "Ny samling",
  "account.field_overflow": "Visa hela innehållet",
  "account.filters.all": "All aktivitet",
  "account.filters.boosts_toggle": "Visa boostar",
  "account.filters.posts_boosts": "Inlägg och boostar",
  "account.filters.posts_only": "Inlägg",
  "account.filters.posts_replies": "Inlägg och svar",
  "account.filters.replies_toggle": "Visa svar",
  "account.follow": "Följ",
  "account.follow_back": "Följ tillbaka",
  "account.follow_back_short": "Följ tillbaka",
  "account.follow_request": "Begär att följa",
  "account.follow_request_cancel": "Avbryt begäran",
  "account.follow_request_cancel_short": "Avbryt",
  "account.follow_request_short": "Begär",
  "account.followers": "Följare",
  "account.followers.empty": "Ingen följer denna användare än.",
  "account.followers_counter": "{count, plural, one {{counter} följare} other {{counter} följare}}",
  "account.followers_you_know_counter": "{counter} du känner",
  "account.following": "Följer",
  "account.following_counter": "{count, plural, one {{counter} följer} other {{counter} följer}}",
  "account.follows.empty": "Denna användare följer inte någon än.",
  "account.follows_you": "Följer dig",
  "account.go_to_profile": "Gå till profilen",
  "account.hame.invalid_handle": "Användarnamnet ej tillgängligt",
  "account.hide_reblogs": "Dölj boostar från @{name}",
  "account.in_memoriam": "Till minne av.",
  "account.join_modal.day": "Dag",
  "account.join_modal.me": "Du gick med i {server} den",
  "account.join_modal.me_anniversary": "Grattis på ditt fediversum-jubileum! Du anslöt till {server} på",
  "account.join_modal.me_today": "Det är din första dag på {server}!",
  "account.join_modal.other": "{name} gick med i {server} den",
  "account.join_modal.other_today": "Det är {name}s första dag på {server}!",
  "account.join_modal.share.celebrate": "Dela ett firande inlägg",
  "account.join_modal.share.intro": "Dela ett introduktionsinlägg",
  "account.join_modal.share.welcome": "Dela ett välkomstinlägg",
  "account.join_modal.years": "{number, plural, one {# år} other {# år}}",
  "account.joined_short": "Gick med",
  "account.languages": "Ändra vilka språk du helst vill se i ditt flöde",
  "account.last_active": "Senast aktiv",
  "account.link_verified_on": "Ägarskap för denna länk kontrollerades den {date}",
  "account.locked_info": "Detta konto har låst integritetsstatus. Ägaren väljer manuellt vem som kan följa det.",
  "account.media": "Media",
  "account.mention": "Nämn @{name}",
  "account.menu.add_to_collection": "Lägg till i samling…",
  "account.menu.add_to_list": "Lägg till i lista…",
  "account.menu.block": "Blockera konto",
  "account.menu.block_domain": "Blockera {domain}",
  "account.menu.copied": "Kopierade kontolänk till urklipp",
  "account.menu.copy": "Kopiera länk",
  "account.menu.direct": "Nämn privat",
  "account.menu.hide_reblogs": "Dölj boostar i tidslinjen",
  "account.menu.mention": "Nämn",
  "account.menu.mute": "Tysta konto",
  "account.menu.note.description": "Endast synlig för dig",
  "account.menu.open_original_page": "Visa på {domain}",
  "account.menu.open_original_page_no_domain": "Visa på originalservern",
  "account.menu.remove_follower": "Ta bort följare",
  "account.menu.report": "Anmäl konto",
  "account.menu.share": "Dela…",
  "account.menu.show_reblogs": "Visa boostar i tidslinjen",
  "account.menu.unblock": "Avblockera konto",
  "account.menu.unblock_domain": "Avblockera {domain}",
  "account.menu.unmute": "Avtysta konto",
  "account.moved_to": "{name} har indikerat att hen har ett nytt konto:",
  "account.mute": "Tysta @{name}",
  "account.mute_notifications_short": "Stäng av aviseringsljud",
  "account.mute_short": "Tysta",
  "account.muted": "Tystad",
  "account.mutual": "Ni följer varandra",
  "account.name.copy": "Kopiera handtag",
  "account.name.help.domain": "{domain} är servern som är värd för användarens profil och inlägg.",
  "account.name.help.domain_self": "{domain} är din server som är värd för användarens profil och inlägg.",
  "account.name.help.footer": "Precis som du kan skicka e-post till personer som använder olika e-postleverantörer, kan du interagera med personer på andra Mastodon-servrar, och med vem som helst på andra Fedivers-appar.",
  "account.name.help.header": "Ett handtag är som en e-postadress",
  "account.name.help.invalid_explanation": "Detta kan hända när en användare byter användarnamn och är i allmänhet tillfälligt. Om detta kvarstår, kan det bero på en otillgänglig server eller någon felaktig konfiguration på deras ände.",
  "account.name.help.invalid_header": "Denna användares användarnamn håller på att uppdateras",
  "account.name.help.username": "{username} är kontots användarnamn på deras server. Någon på en annan server kan ha samma användarnamn.",
  "account.name.help.username_self": "{username} är ditt användarnamn på denna server. Någon på en annan server kan ha samma användarnamn.",
  "account.name_info": "Vad betyder detta?",
  "account.no_bio": "Ingen beskrivning angiven.",
  "account.node_modal.callout": "Personlig anteckningar är endast synliga för dig.",
  "account.node_modal.edit_title": "Redigera en personlig anteckning",
  "account.node_modal.error_unknown": "Kunde inte spara anteckningen",
  "account.node_modal.field_label": "Personlig anteckning",
  "account.node_modal.save": "Spara",
  "account.node_modal.title": "Lägg till en personlig anteckning",
  "account.note.edit_button": "Redigera",
  "account.note.title": "Personlig anteckning (endast synlig för dig)",
  "account.open_original_page": "Öppna den ursprungliga sidan",
  "account.pending": "Väntande",
  "account.posts": "Inlägg",
  "account.remove_from_followers": "Ta bort {name} från följare",
  "account.report": "Rapportera @{name}",
  "account.requested_follow": "{name} har begärt att följa dig",
  "account.share": "Dela @{name}s profil",
  "account.show_reblogs": "Visa boostar från @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} inlägg} other {{counter} inlägg}}",
  "account.timeline.pinned": "Fastnålad",
  "account.timeline.pinned.view_all": "Visa alla fästa inlägg",
  "account.unblock": "Avblockera @{name}",
  "account.unblock_domain": "Avblockera {domain}",
  "account.unblock_domain_short": "Avblockera",
  "account.unblock_short": "Avblockera",
  "account.unendorse": "Visa inte på profil",
  "account.unfollow": "Sluta följ",
  "account.unmute": "Sluta tysta @{name}",
  "account.unmute_notifications_short": "Aktivera aviseringsljud",
  "account.unmute_short": "Avtysta",
  "account_edit.advanced_settings.bot_hint": "Signalera till andra att kontot huvudsakligen utför automatiserade åtgärder och kanske inte övervakas",
  "account_edit.advanced_settings.bot_label": "Automatiserat konto",
  "account_edit.advanced_settings.title": "Avancerade inställningar",
  "account_edit.bio.add_label": "Lägg till biografi",
  "account_edit.bio.edit_label": "Redigera biografi",
  "account_edit.bio.placeholder": "Lägg till en kort introduktion för att hjälpa andra att identifiera dig.",
  "account_edit.bio.title": "Biografi",
  "account_edit.bio_modal.add_title": "Lägg till biografi",
  "account_edit.bio_modal.edit_title": "Redigera biografi",
  "account_edit.column_button": "Klar",
  "account_edit.column_title": "Redigera profil",
  "account_edit.custom_fields.add_label": "Lägg till fält",
  "account_edit.custom_fields.edit_label": "Redigera fält",
  "account_edit.custom_fields.placeholder": "Lägg till dina pronomen, externa länkar eller något annat du vill dela.",
  "account_edit.custom_fields.reorder_button": "Ändra ordning för fält",
  "account_edit.custom_fields.tip_content": "Du kan enkelt lägga till trovärdighet till ditt Mastodon-konto genom att verifiera länkar till alla webbplatser du äger.",
  "account_edit.custom_fields.tip_title": "Tips: Lägga till verifierade länkar",
  "account_edit.custom_fields.title": "Anpassade fält",
  "account_edit.custom_fields.verified_hint": "Hur lägger jag till en verifierad länk?",
  "account_edit.display_name.add_label": "Lägg till visningsnamn",
  "account_edit.display_name.edit_label": "Redigera visningsnamn",
  "account_edit.display_name.placeholder": "Visningsnamnet är hur ditt namn ser ut på din profil och i tidslinjer.",
  "account_edit.display_name.title": "Visningsnamn",
  "account_edit.featured_hashtags.edit_label": "Lägg till hashtaggar",
  "account_edit.featured_hashtags.placeholder": "Hjälp andra att identifiera, och få snabb tillgång till, dina favoritämnen.",
  "account_edit.featured_hashtags.title": "Utvalda hashtaggar",
  "account_edit.field_actions.delete": "Radera fält",
  "account_edit.field_actions.edit": "Redigera fält",
  "account_edit.field_delete_modal.confirm": "Är du säker på att du vill ta bort detta tilläggsfält? Denna åtgärd kan inte ångras.",
  "account_edit.field_delete_modal.delete_button": "Radera",
  "account_edit.field_delete_modal.title": "Radera anpassat fält?",
  "account_edit.field_edit_modal.add_title": "Lägg till anpassad fält",
  "account_edit.field_edit_modal.discard_confirm": "Släng",
  "account_edit.field_edit_modal.discard_message": "Du har osparade ändringar. Är du säker på att du vill ta bort dem?",
  "account_edit.field_edit_modal.edit_title": "Redigera tilläggsfält",
  "account_edit.field_edit_modal.length_warning": "Rekommenderad teckengräns överskrids. Mobilanvändare kanske inte ser ditt fält i sin helhet.",
  "account_edit.field_edit_modal.link_emoji_warning": "Vi rekommenderar att anpassade emoji inte används i kombination med webbadresser. Anpassade fält som innehåller båda kommer endast att visas som text i stället för som en länk för att förhindra förvirring bland användare.",
  "account_edit.field_edit_modal.name_hint": "T.ex. “Personlig webbplats”",
  "account_edit.field_edit_modal.name_label": "Etikett",
  "account_edit.field_edit_modal.url_warning": "För att lägga till en länk, vänligen inkludera {protocol} i början.",
  "account_edit.field_edit_modal.value_hint": "T.ex. \"https://example.me”",
  "account_edit.field_edit_modal.value_label": "Värde",
  "account_edit.field_reorder_modal.drag_cancel": "Flytten avbröts. Fältet \"{item}\" släpptes.",
  "account_edit.field_reorder_modal.drag_end": "Fältet \"{item}\" har tagits bort.",
  "account_edit.field_reorder_modal.drag_instructions": "För att organisera om anpassade fält, tryck på mellanslag eller retur. Använd piltangenterna för att flytta fältet upp eller ner. Tryck på mellanslag eller retur igen för att släppa fältet i sin nya position, eller tryck Esc för att avbryta.",
  "account_edit.field_reorder_modal.drag_move": "Fältet \"{item}\" har flyttats.",
  "account_edit.field_reorder_modal.drag_over": "Fältet \"{item}\" flyttades över \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Plockade upp fält \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Dra fält \"{item}\"",
  "account_edit.field_reorder_modal.title": "Organisera om fält",
  "account_edit.image_alt_modal.add_title": "Lägg till alternativ text",
  "account_edit.image_alt_modal.details_content": "RÄTT: <ul> <li>Beskriv dig själv som avbildad</li> <li>Tala om din själv i tredje person (t.ex. “Alex” istället för “jag”)</li> <li>Var kortfattad – några ord räcker ofta</li> </ul> FEL: <ul> <li>Börja med “Foto av” – det är överflödigt för skärmläsarna</li> </ul> EXEMPEL: <ul> <li>“Alex iklädd en grön skjorta och glasögon”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tips: Alternativ text för profilbilder",
  "account_edit.image_alt_modal.edit_title": "Redigera alternativ text",
  "account_edit.image_alt_modal.text_hint": "Alternativ text hjälper användare av skärmläsare att förstå ditt innehåll.",
  "account_edit.image_alt_modal.text_label": "Alternativ text",
  "account_edit.image_delete_modal.confirm": "Är du säker du vill ta bort denna bild? Denna åtgärd kan inte ångras.",
  "account_edit.image_delete_modal.delete_button": "Radera",
  "account_edit.image_delete_modal.title": "Radera bild?",
  "account_edit.image_edit.add_button": "Lägg till bild",
  "account_edit.image_edit.alt_add_button": "Lägg till alternativtext",
  "account_edit.image_edit.alt_edit_button": "Redigera alternativtext",
  "account_edit.image_edit.remove_button": "Ta bort bild",
  "account_edit.image_edit.replace_button": "Ersätt bild",
  "account_edit.item_list.delete": "Radera {name}",
  "account_edit.item_list.edit": "Redigera {name}",
  "account_edit.name_modal.add_title": "Lägg till visningsnamn",
  "account_edit.name_modal.edit_title": "Redigera visningsnamn",
  "account_edit.profile_tab.button_label": "Anpassa",
  "account_edit.profile_tab.hint.description": "Dessa inställningar anpassar vad användare ser på {server} i de officiella apparna, men de kanske inte gäller för användare på andra servrar och tredjepartsappar.",
  "account_edit.profile_tab.hint.title": "Hur detta visas varierar fortfarande",
  "account_edit.profile_tab.show_featured.description": "‘Utvalda’ är en valfri flik där du kan visa upp andra konton.",
  "account_edit.profile_tab.show_featured.title": "Visa fliken 'Utvalda'",
  "account_edit.profile_tab.show_media.description": "‘Media’ är en valfri flik som visar dina inlägg som innehåller bilder eller videor.",
  "account_edit.profile_tab.show_media.title": "Visa fliken ‘Media’",
  "account_edit.profile_tab.show_media_replies.description": "När den är aktiverad visar fliken Media både dina inlägg och svar på andras inlägg.",
  "account_edit.profile_tab.show_media_replies.title": "Inkludera svar på fliken Media",
  "account_edit.profile_tab.show_relations.description": "Visar konton som du följer och följare till andra användare i din profil. Folk kommer fortfarande att kunna se om du följer dem.",
  "account_edit.profile_tab.show_relations.title": "Visa ‘Följare’ och ‘Följer’",
  "account_edit.profile_tab.subtitle": "Anpassa hur din profil visas.",
  "account_edit.profile_tab.title": "Inställningar för profilvisning",
  "account_edit.save": "Spara",
  "account_edit.upload_modal.back": "Tillbaka",
  "account_edit.upload_modal.done": "Färdig",
  "account_edit.upload_modal.next": "Nästa",
  "account_edit.upload_modal.step_crop.zoom": "Zooma",
  "account_edit.upload_modal.step_upload.button": "Bläddra bland filer",
  "account_edit.upload_modal.step_upload.dragging": "Släpp för att ladda upp",
  "account_edit.upload_modal.step_upload.header": "Välj en bild",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF eller JPG-format, upp till {limit}MB.{br}Bild kommer att skalas till {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Lägg till profilbild",
  "account_edit.upload_modal.title_add.header": "Lägg till omslagsbild",
  "account_edit.upload_modal.title_replace.avatar": "Ersätt profilbild",
  "account_edit.upload_modal.title_replace.header": "Ersätt omslagsbild",
  "account_edit.verified_modal.details": "Öka trovärdigheten för din Mastodon-profil genom att verifiera länkar till personliga webbplatser. Så här fungerar det:",
  "account_edit.verified_modal.invisible_link.details": "Lägg till länken till din överskrift. Den viktiga delen är rel=\"me\" som förhindrar personifiering på webbplatser med användargenererat innehåll. Du kan även använda en länktagg i överskriften på sidan istället för {tag}, men HTML:en måste vara tillgänglig utan att exekvera JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Hur gör jag länken osynlig?",
  "account_edit.verified_modal.step1.header": "Kopiera HTML-koden nedan och klistra in i överskriften för din webbplats",
  "account_edit.verified_modal.step2.details": "Om du redan har lagt till din webbplats som ett anpassat fält måste du ta bort och lägga till den igen för att utlösa verifiering.",
  "account_edit.verified_modal.step2.header": "Lägg till din webbplats som ett anpassat fält",
  "account_edit.verified_modal.title": "Hur man lägger till en verifierad länk",
  "account_edit_tags.add_tag": "Lägg till #{tagName}",
  "account_edit_tags.column_title": "Redigera taggar",
  "account_edit_tags.help_text": "Utvalda hashtaggar hjälper användare att upptäcka och interagera med din profil. De visas som filter på din profilsidas aktivitetsvy.",
  "account_edit_tags.max_tags_reached": "Du har nått det maximala antalet utvalda hashtaggar.",
  "account_edit_tags.search_placeholder": "Ange en hashtagg…",
  "account_edit_tags.suggestions": "Förslag:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# inlägg} other {# inlägg}}",
  "account_list.hidden_notice": "Detta är endast synligt för dig. För att visa denna lista för andra, gå till <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# konto} other {# konton}}",
  "admin.dashboard.daily_retention": "Användarlojalitet per dag efter registrering",
  "admin.dashboard.monthly_retention": "Användarlojalitet per månad efter registrering",
  "admin.dashboard.retention.average": "Genomsnittlig",
  "admin.dashboard.retention.cohort": "Registreringsmånad",
  "admin.dashboard.retention.cohort_size": "Nya användare",
  "admin.impact_report.instance_accounts": "Kontoprofiler som det här skulle ta bort",
  "admin.impact_report.instance_followers": "Följare som våra användare skulle förlora",
  "admin.impact_report.instance_follows": "Följare som deras användare skulle förlora",
  "admin.impact_report.title": "Sammanfattning av påverkan",
  "alert.need_reload.message": "Mastodon har uppdaterats. Vissa saker kanske inte fungerar korrekt förrän du laddar om sidan.",
  "alert.rate_limited.message": "Vänligen försök igen efter {retry_time, time, medium}.",
  "alert.rate_limited.title": "Hastighetsbegränsad",
  "alert.unexpected.message": "Ett oväntat fel uppstod.",
  "alert.unexpected.title": "Hoppsan!",
  "alt_text_badge.title": "Alt-Text",
  "alt_text_modal.add_alt_text": "Lägg till alt-text",
  "alt_text_modal.add_text_from_image": "Lägg till text från bild",
  "alt_text_modal.cancel": "Avbryt",
  "alt_text_modal.change_thumbnail": "Ändra miniatyr",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Beskriv detta för personer med hörselnedsättning…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Beskriv detta för personer med synnedsättning…",
  "alt_text_modal.done": "Klar",
  "announcement.announcement": "Kungörelse",
  "annual_report.announcement.action_build": "Bygg min Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nej tack",
  "annual_report.announcement.action_view": "Visa min Wrapstodon",
  "annual_report.announcement.description": "Upptäck mer om ditt engagemang i Mastodon under det senaste året.",
  "annual_report.announcement.title": "Wrapstodon {year} har anlänt",
  "annual_report.nav_item.badge": "Ny",
  "annual_report.shared_page.donate": "Donera",
  "annual_report.shared_page.footer": "Genererad med {heart} av Mastodon-teamet",
  "annual_report.shared_page.footer_server_info": "{username} använder {domain}, en av många forum som drivs av Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} letade efter inlägg att boosta och lyfte fram andra skapare med perfekt precision.",
  "annual_report.summary.archetype.booster.desc_self": "Du letade efter inlägg att boosta och lyfte fram andra skapare med perfekt precision.",
  "annual_report.summary.archetype.booster.name": "Bågskytten",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Vi vet att {name} var där ute någonstans och njuter av Mastodon på sitt egna tysta sätt.",
  "annual_report.summary.archetype.lurker.desc_self": "Vi vet att ni var där ute någonstans och njuter av Mastodon på ert egna tysta sätt.",
  "annual_report.summary.archetype.lurker.name": "Den stoiska",
  "annual_report.summary.archetype.oracle.desc_public": "{name} skapade nya inlägg mer än svar och höll Mastodon fräscht och framtidsinriktat.",
  "annual_report.summary.archetype.oracle.desc_self": "Du skapade nya inlägg mer än svar och höll Mastodon fräscht och framtidsinriktat.",
  "annual_report.summary.archetype.oracle.name": "Oraklet",
  "annual_report.summary.archetype.pollster.desc_public": "{name} skapade fler undersökningar än andra inläggstyper och skapade nyfikenhet på Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Du skapade fler undersökningar än andra inläggstyper och skapade nyfikenhet på Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Undraren",
  "annual_report.summary.archetype.replier.desc_public": "{name} svarade ofta på andras inlägg och pollinerade Mastodon med nya diskussioner.",
  "annual_report.summary.archetype.replier.desc_self": "Du svarade ofta på andras inlägg och pollinerade Mastodon med nya diskussioner.",
  "annual_report.summary.archetype.replier.name": "Fjärilen",
  "annual_report.summary.archetype.reveal": "Avslöja min arketyp",
  "annual_report.summary.archetype.reveal_description": "Tack för att du är en del av Mastodon! Dags att ta reda på vilken arketyp du förkroppsligade under {year}.",
  "annual_report.summary.archetype.title_public": "{name}s arketyp",
  "annual_report.summary.archetype.title_self": "Din arketyp",
  "annual_report.summary.close": "Stäng",
  "annual_report.summary.copy_link": "Kopiera länk",
  "annual_report.summary.followers.new_followers": "{count, plural, one {ny följare} other {nya följare}}",
  "annual_report.summary.highlighted_post.boost_count": "Det här inlägget boostades {count, plural, one {en gång} other {# gånger}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Det här inlägget favoritmarkerades {count, plural, one {en gång} other {# gånger}}.",
  "annual_report.summary.highlighted_post.reply_count": "Det här inlägget fick {count, plural, one {ett svar} other {# svar}}.",
  "annual_report.summary.highlighted_post.title": "Mest populära inlägg",
  "annual_report.summary.most_used_app.most_used_app": "mest använda app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "mest använda hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Du inkluderade denna hashtag i {count, plural, one {ett inlägg} other {# inlägg}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} inkluderade denna hashtag i {count, plural, one {ett inlägg} other {# inlägg}}.",
  "annual_report.summary.new_posts.new_posts": "nya inlägg",
  "annual_report.summary.percentile.text": "<topLabel>Det placerar dig i topp</topLabel><percentage></percentage><bottomLabel>bland {domain} användare.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Vi berättar inte för Bernie.",
  "annual_report.summary.share_elsewhere": "Dela någon annanstans",
  "annual_report.summary.share_message": "Jag fick {archetype}-arketypen!",
  "annual_report.summary.share_on_mastodon": "Dela på Mastodon",
  "attachments_list.unprocessed": "(obehandlad)",
  "audio.hide": "Dölj ljud",
  "block_modal.no_collections": "Varken av er kan lägga till varandra i samlingar. Ni kommer automatiskt att tas bort från varandras befintliga samlingar, om de finns.",
  "block_modal.remote_users_caveat": "Vi kommer att be servern {domain} att respektera ditt beslut. Dock garanteras inte efterlevnad eftersom vissa servrar kan hantera blockeringar på olika sätt. Offentliga inlägg kan fortfarande vara synliga för icke-inloggade användare.",
  "block_modal.show_less": "Visa mindre",
  "block_modal.show_more": "Visa mer",
  "block_modal.they_cant_mention": "Ni kan inte nämna, följa eller citera varandra.",
  "block_modal.they_cant_see_posts": "De kan inte se ditt innehåll och du kommer inte att se deras.",
  "block_modal.they_will_know": "De kan se att de är blockerade.",
  "block_modal.title": "Blockera användare?",
  "block_modal.you_wont_see_mentions": "Du kommer inte att se inlägg från andra som nämner dem.",
  "boost_modal.combo": "Du kan trycka på {combo} för att hoppa över detta nästa gång",
  "boost_modal.reblog": "Boosta inlägg?",
  "boost_modal.undo_reblog": "Avboosta inlägg?",
  "bundle_column_error.copy_stacktrace": "Kopiera felrapport",
  "bundle_column_error.error.body": "Den begärda sidan kunde inte visas. Det kan bero på ett fel i vår kod eller ett problem med webbläsarens kompatibilitet.",
  "bundle_column_error.error.title": "Åh nej!",
  "bundle_column_error.network.body": "Det uppstod ett fel när denna sida skulle visas. Detta kan bero på ett tillfälligt problem med din internetanslutning eller med servern.",
  "bundle_column_error.network.title": "Nätverksfel",
  "bundle_column_error.retry": "Försök igen",
  "bundle_column_error.return": "Tillbaka till startsidan",
  "bundle_column_error.routing.body": "Den begärda sidan kunde inte hittas. Är du säker på att adressen angivits korrekt?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Stäng",
  "bundle_modal_error.message": "Något gick fel när skärmen laddades.",
  "bundle_modal_error.retry": "Försök igen",
  "callout.dismiss": "Avfärda",
  "carousel.current": "<sr>Bild</sr>{current, number} / {max, number}",
  "carousel.slide": "Bild {current, number} av {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} rekommenderade tecken",
  "character_counter.required": "{currentLength}/{maxLength} tecken",
  "closed_registrations.other_server_instructions": "Eftersom Mastodon är decentraliserat kan du skapa ett konto på en annan server och fortfarande interagera med denna.",
  "closed_registrations_modal.description": "Det är för närvarande inte möjligt att skapa ett konto på {domain} men kom ihåg att du inte behöver ett konto specifikt på {domain} för att använda Mastodon.",
  "closed_registrations_modal.find_another_server": "Hitta en annan server",
  "closed_registrations_modal.preamble": "Mastodon är decentraliserat så oavsett var du skapar ditt konto kommer du att kunna följa och interagera med någon på denna server. Du kan också köra din egen server!",
  "closed_registrations_modal.title": "Registrera dig på Mastodon",
  "collection.share_modal.share_link_label": "Dela länk",
  "collection.share_modal.share_via_post": "Publicera på Mastodon",
  "collection.share_modal.share_via_system": "Dela med…",
  "collection.share_modal.title": "Dela samling",
  "collection.share_modal.title_new": "Dela din nya samling!",
  "collection.share_template_other": "Kolla in denna coola samling:",
  "collection.share_template_own": "Kolla in min nya samling:",
  "collections.account_count": "{count, plural, one {# konto} other {# konton}}",
  "collections.accounts.empty_description": "Lägg till upp till {count} konton",
  "collections.accounts.empty_editor_title": "Ingen finns i denna samling ännu",
  "collections.accounts.empty_title": "Denna samling är tom",
  "collections.add_to_collection": "Lägg till {name} i samlingar",
  "collections.block_collection_owner": "Blockera konto",
  "collections.by_account": "av {account_handle}",
  "collections.collection_description": "Beskrivning",
  "collections.collection_language": "Språk",
  "collections.collection_language_none": "Inga",
  "collections.collection_name": "Namn",
  "collections.collection_topic": "Ämne",
  "collections.confirm_account_removal": "Är du säker på att du vill ta bort detta konto från denna samling?",
  "collections.content_warning": "Innehållsvarning",
  "collections.continue": "Fortsätt",
  "collections.copy_link": "Kopiera länk",
  "collections.copy_link_confirmation": "Kopierade samlingslänk till urklipp",
  "collections.create.accounts_title": "Vem kommer du att visa i den här samlingen?",
  "collections.create.basic_details_title": "Grundläggande detaljer",
  "collections.create.steps": "Steg {step}/{total}",
  "collections.create_collection": "Skapa samling",
  "collections.create_new_collection": "Skapa ny samling",
  "collections.delete_collection": "Radera samling",
  "collections.description_length_hint": "Begränsat till 100 tecken",
  "collections.detail.author_added_you_on_date": "{author} lade till dig {date}",
  "collections.detail.loading": "Laddar samling…",
  "collections.detail.revoke_inclusion": "Ta bort mig",
  "collections.detail.sensitive_content": "Känsligt innehåll",
  "collections.detail.sensitive_note": "Beskrivningen och dessa konton är kanske inte lämpliga för alla tittare.",
  "collections.detail.share": "Dela denna samling",
  "collections.detail.you_are_in_this_collection": "Du är med i denna samling",
  "collections.edit_details": "Redigera detaljer",
  "collections.error_loading_collections": "Det uppstod ett fel när dessa samlingar skulle laddas.",
  "collections.hidden_accounts_description": "Du har blockerat eller tystat {count, plural, one {denna användare} other {dessa användare}}",
  "collections.hidden_accounts_link": "{count, plural, one {# gömt konto} other {# gömda konton}}",
  "collections.hints.accounts_counter": "{count}/{max} konton",
  "collections.last_updated_at": "Senast uppdaterad: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# samling} other {# samlingar}}",
  "collections.list.created_by_author": "Skapad av {name}",
  "collections.list.created_by_you": "Skapad av dig",
  "collections.list.featuring_you": "Med dig",
  "collections.manage_accounts": "Hantera konton",
  "collections.mark_as_sensitive": "Markera som känsligt innehåll",
  "collections.mark_as_sensitive_hint": "Döljer samlingens beskrivning och konton bakom en innehållsvarning. Samlingsnamnet kommer fortfarande att vara synligt.",
  "collections.maximum_collection_count_description": "Din server gör det möjligt att skapa upp till {count} samlingar.",
  "collections.maximum_collection_count_reached": "Du har skapat det maximala antalet samlingar",
  "collections.name_length_hint": "Begränsat till 40 tecken",
  "collections.new_collection": "Ny samling",
  "collections.pending_accounts.message": "Konton kan visas som väntande när vi väntar på ett svar från användaren eller deras server. Endast du kan se väntande konton.",
  "collections.pending_accounts.title": "Varför ser jag väntande konton?",
  "collections.remove_account": "Ta bort",
  "collections.report_collection": "Rapportera denna samling",
  "collections.revoke_collection_inclusion": "Ta bort mig själv från denna samling",
  "collections.revoke_inclusion.confirmation": "Du har tagits bort från \"{collection}\"",
  "collections.revoke_inclusion.error": "Ett fel uppstod, försök igen senare.",
  "collections.search_accounts_label": "Sök efter ett konto att lägga till",
  "collections.search_accounts_max_reached": "Du har lagt till maximalt antal konton",
  "collections.sensitive": "Känsligt",
  "collections.share_short": "Dela",
  "collections.sort_alphabetical": "Alfabetiskt",
  "collections.sort_by": "Sortera efter:",
  "collections.sort_date_added": "Datum tillagd",
  "collections.sort_last_active": "Senast aktiv",
  "collections.sort_most_followers": "Flest följare",
  "collections.suggestions.can_not_add": "Kan inte läggas till",
  "collections.suggestions.can_not_add_desc": "Dessa konton kan ha valt bort upptäckt, eller kan de vara på en server som inte stöder samlingar.",
  "collections.suggestions.must_follow": "Måste följa först",
  "collections.suggestions.must_follow_desc": "Dessa konton granskar alla följa förfrågningar. Följare kan lägga till dem i samlingar.",
  "collections.topic_hint": "Lägg till en hashtagg som hjälper andra att förstå huvudämnet i denna samling.",
  "collections.topic_special_chars_hint": "Specialtecken kommer att tas bort när du sparar",
  "collections.unlisted_collections_description": "Dessa visas inte på din profil till andra. Vem som helst med länken kan upptäcka dem.",
  "collections.unlisted_collections_with_count": "Olistade samlingar ({count})",
  "collections.view_collection": "Visa samling",
  "collections.visibility_public": "Offentlig",
  "collections.visibility_public_hint": "Upptäckbar i sökresultat och andra områden där rekommendationer visas.",
  "collections.visibility_title": "Synlighet",
  "collections.visibility_unlisted": "Olistad",
  "collections.visibility_unlisted_hint": "Synlig för alla med en länk. Gömd från sökresultat och rekommendationer.",
  "column.about": "Om",
  "column.blocks": "Blockerade användare",
  "column.bookmarks": "Bokmärken",
  "column.community": "Lokal tidslinje",
  "column.create_list": "Skapa lista",
  "column.direct": "Privata omnämnande",
  "column.directory": "Bläddra bland profiler",
  "column.domain_blocks": "Blockerade domäner",
  "column.edit_list": "Redigera lista",
  "column.favourites": "Favoriter",
  "column.firehose": "Direktflöden",
  "column.firehose_local": "Direktflöde för den här servern",
  "column.firehose_singular": "Direktflöde",
  "column.follow_requests": "Följarförfrågningar",
  "column.home": "Hem",
  "column.list_members": "Hantera listmedlemmar",
  "column.lists": "Listor",
  "column.mutes": "Tystade användare",
  "column.notifications": "Notifikationer",
  "column.other_collections": "Samlingar av {name}",
  "column.pins": "Fästa inlägg",
  "column.public": "Global tidslinje",
  "column.your_collections": "Dina samlingar",
  "column_back_button.label": "Tillbaka",
  "column_header.hide_settings": "Dölj inställningar",
  "column_header.moveLeft_settings": "Flytta kolumnen åt vänster",
  "column_header.moveRight_settings": "Flytta kolumnen åt höger",
  "column_header.pin": "Fäst",
  "column_header.show_settings": "Visa inställningar",
  "column_header.unpin": "Ångra fäst",
  "column_search.cancel": "Avbryt",
  "combobox.close_results": "Stäng resultat",
  "combobox.loading": "Laddar",
  "combobox.no_results_found": "Inga resultat för denna sökning",
  "combobox.open_results": "Öppna resultat",
  "combobox.results_available": "{count, plural, one {# förslag tillgängligt} other {# förslag tillgängliga}}. Använd upp- och ner-piltangenterna för att navigera. Tryck på Retur för att välja.",
  "community.column_settings.local_only": "Endast lokalt",
  "community.column_settings.media_only": "Endast media",
  "community.column_settings.remote_only": "Endast fjärr",
  "compose.error.blank_post": "Inlägget kan inte vara tomt.",
  "compose.language.change": "Ändra språk",
  "compose.language.search": "Sök språk...",
  "compose.published.body": "Inlägget publicerat.",
  "compose.published.open": "Visa",
  "compose.saved.body": "Inlägg sparad.",
  "compose_form.direct_message_warning_learn_more": "Läs mer",
  "compose_form.encryption_warning": "Inlägg på Mastodon är inte obrutet krypterade. Dela inte känslig information på Mastodon.",
  "compose_form.hashtag_warning": "Inlägget listas inte under någon hashtag eftersom det inte är offentligt. Endast offentliga inlägg går att söka med en hashtag.",
  "compose_form.lock_disclaimer": "Ditt konto är inte {locked}. Vem som helst kan följa dig för att se dina inlägg som endast är för följare.",
  "compose_form.lock_disclaimer.lock": "låst",
  "compose_form.placeholder": "Vad tänker du på?",
  "compose_form.poll.duration": "Varaktighet för omröstning",
  "compose_form.poll.multiple": "Flera val",
  "compose_form.poll.option_placeholder": "Alternativ {number}",
  "compose_form.poll.single": "Enval",
  "compose_form.poll.switch_to_multiple": "Ändra enkät för att tillåta flera val",
  "compose_form.poll.switch_to_single": "Ändra enkät för att tillåta ett enda val",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Publicera",
  "compose_form.reply": "Svara",
  "compose_form.save_changes": "Uppdatera",
  "compose_form.spoiler.marked": "Texten är dold bakom en varning",
  "compose_form.spoiler.unmarked": "Texten är inte dold",
  "compose_form.spoiler_placeholder": "Innehållsvarning (valfritt)",
  "confirmation_modal.cancel": "Avbryt",
  "confirmations.block.confirm": "Blockera",
  "confirmations.delete.confirm": "Radera",
  "confirmations.delete.message": "Är du säker på att du vill radera detta inlägg?",
  "confirmations.delete.title": "Ta bort inlägg?",
  "confirmations.delete_collection.confirm": "Radera",
  "confirmations.delete_collection.message": "Denna åtgärd kan inte ångras.",
  "confirmations.delete_collection.title": "Radera \"{name}\"?",
  "confirmations.delete_list.confirm": "Radera",
  "confirmations.delete_list.message": "Är du säker på att du vill radera denna lista permanent?",
  "confirmations.delete_list.title": "Ta bort listan?",
  "confirmations.discard_draft.confirm": "Släng bort och fortsätt",
  "confirmations.discard_draft.edit.cancel": "Fortsätt redigera",
  "confirmations.discard_draft.edit.message": "Fortsätter du, kommer ändringarna till inlägget att förkastas.",
  "confirmations.discard_draft.edit.title": "Vill du förkasta ändringarna i inlägget?",
  "confirmations.discard_draft.post.cancel": "Återuppta utkast",
  "confirmations.discard_draft.post.message": "Fortsätter du, kommer inlägget du skriver att förkastas.",
  "confirmations.discard_draft.post.title": "Vill du förkasta utkastet?",
  "confirmations.discard_edit_media.confirm": "Kasta",
  "confirmations.discard_edit_media.message": "Du har osparade ändringar till mediabeskrivningen eller förhandsgranskningen, kasta bort dem ändå?",
  "confirmations.follow_to_list.confirm": "Följ och lägg till i listan",
  "confirmations.follow_to_list.message": "Du måste följa {name} för att lägga till dem i en lista.",
  "confirmations.follow_to_list.title": "Följ användare?",
  "confirmations.hide_featured_tab.confirm": "Dölj flik",
  "confirmations.hide_featured_tab.intro": "Du kan ändra detta när som helst under <i>Redigera profil > Inställningar för profilfliken</i>.",
  "confirmations.hide_featured_tab.message": "Detta kommer att dölja fliken för användare på {serverName} och andra servrar som kör den senaste versionen av Mastodon. Andra visningssätt kan variera.",
  "confirmations.hide_featured_tab.title": "Dölj fliken \"Utvald\"?",
  "confirmations.logout.confirm": "Logga ut",
  "confirmations.logout.message": "Är du säker på att du vill logga ut?",
  "confirmations.logout.title": "Logga ut?",
  "confirmations.missing_alt_text.confirm": "Lägg till alt-text",
  "confirmations.missing_alt_text.message": "Ditt inlägg innehåller media utan alt-text. Om du lägger till beskrivningar blir ditt innehåll tillgängligt för fler personer.",
  "confirmations.missing_alt_text.secondary": "Posta ändå",
  "confirmations.missing_alt_text.title": "Lägg till alt-text?",
  "confirmations.mute.confirm": "Tysta",
  "confirmations.private_quote_notify.cancel": "Tillbaka till redigering",
  "confirmations.private_quote_notify.confirm": "Publicera inlägg",
  "confirmations.private_quote_notify.do_not_show_again": "Visa inte mig detta meddelande igen",
  "confirmations.private_quote_notify.message": "Personen du citerar och andra omnämnda kommer att meddelas och kommer att kunna se ditt inlägg, även om de inte följer dig.",
  "confirmations.private_quote_notify.title": "Dela med följare och omnämnda användare?",
  "confirmations.quiet_post_quote_info.dismiss": "Påminn mig inte igen",
  "confirmations.quiet_post_quote_info.got_it": "Jag förstår",
  "confirmations.quiet_post_quote_info.message": "När du citerar en tyst offentlig post, kommer ditt inlägg att döljas från trendande tidslinjer.",
  "confirmations.quiet_post_quote_info.title": "Citerar tysta offentliga inlägg",
  "confirmations.redraft.confirm": "Radera & gör om",
  "confirmations.redraft.message": "Är du säker på att du vill radera detta inlägg och göra om det? Favoritmarkeringar, boostar och svar till det ursprungliga inlägget kommer förlora sitt sammanhang.",
  "confirmations.redraft.title": "Ta bort & gör om inlägget?",
  "confirmations.remove_from_followers.confirm": "Ta bort följare",
  "confirmations.remove_from_followers.message": "{name} kommer att sluta följa dig. Är du säker på att du vill fortsätta?",
  "confirmations.remove_from_followers.title": "Ta bort följare?",
  "confirmations.revoke_collection_inclusion.confirm": "Ta bort mig",
  "confirmations.revoke_collection_inclusion.message": "Kuratorn kommer inte att kunna lägga till dig igen i denna samling i 24 timmar. För att hindra dem från att lägga till dig till samlingar permanent, kan du blockera dem.",
  "confirmations.revoke_collection_inclusion.title": "Ta bort dig själv från denna samling?",
  "confirmations.revoke_quote.confirm": "Ta bort inlägg",
  "confirmations.revoke_quote.message": "Denna åtgärd kan inte ångras.",
  "confirmations.revoke_quote.title": "Ta bort inlägg?",
  "confirmations.unblock.confirm": "Avblockera",
  "confirmations.unblock.title": "Avblockera {name}?",
  "confirmations.unfollow.confirm": "Avfölj",
  "confirmations.unfollow.title": "Avfölj {name}?",
  "confirmations.withdraw_request.confirm": "Återkalla förfrågan",
  "confirmations.withdraw_request.title": "Återkalla begäran att följa {name}?",
  "content_warning.hide": "Dölj inlägg",
  "content_warning.show": "Visa ändå",
  "content_warning.show_more": "Visa mer",
  "content_warning.show_short": "Visa",
  "conversation.delete": "Radera konversation",
  "conversation.mark_as_read": "Markera som läst",
  "conversation.open": "Visa konversation",
  "conversation.with": "Med {names}",
  "copy_icon_button.copied": "Kopierad till urklipp",
  "copy_icon_button.copy_this_text": "Kopiera länken till urklipp",
  "copypaste.copied": "Kopierad",
  "copypaste.copy_to_clipboard": "Kopiera till urklipp",
  "custom_homepage.about": "Om",
  "custom_homepage.about_this_server": "Om denna server",
  "custom_homepage.administered_by": "Administrerad av",
  "custom_homepage.contact": "Kontakt:",
  "custom_homepage.latest_activity": "Senaste aktivitet",
  "custom_homepage.these_are_the_latest_posts": "Detta är de senaste 40 inläggen från konton på denna server.",
  "directory.federated": "Från känt fediversum",
  "directory.local": "Endast från {domain}",
  "directory.new_arrivals": "Nyanlända",
  "directory.recently_active": "Nyligen aktiva",
  "disabled_account_banner.account_settings": "Kontoinställningar",
  "disabled_account_banner.text": "Ditt konto {disabledAccount} är för närvarande inaktiverat.",
  "dismissable_banner.community_timeline": "Dessa är de senaste offentliga inläggen från personer vars konton tillhandahålls av {domain}.",
  "dismissable_banner.dismiss": "Avfärda",
  "dismissable_banner.public_timeline": "De här är de aktuella publika inlägg från personer i fediversum som personer i {domain} följer.",
  "domain_block_modal.block": "Blockera server",
  "domain_block_modal.block_account_instead": "Blockera @{name} istället",
  "domain_block_modal.they_can_interact_with_old_posts": "Personer från denna server kan interagera med dina gamla inlägg.",
  "domain_block_modal.they_cant_follow": "Ingen från denna server kan följa dig.",
  "domain_block_modal.they_wont_know": "De kommer inte veta att de har blockerats.",
  "domain_block_modal.title": "Blockera domän?",
  "domain_block_modal.you_will_lose_num_followers": "Du kommer att förlora {followersCount, plural, other {{followersCountDisplay} följare}} och {followingCount, plural, one {{followingCountDisplay} person du följer} other {{followingCountDisplay} personer du följer}}.",
  "domain_block_modal.you_will_lose_relationships": "Du kommer att förlora alla följare och personer du följer från denna server.",
  "domain_block_modal.you_wont_see_posts": "Du kommer inte att se inlägg eller meddelanden från användare på den här servern.",
  "dropdown.empty": "Välj ett alternativ",
  "email_subscriptions.email": "E-post",
  "email_subscriptions.form.action": "Prenumerera",
  "email_subscriptions.form.bottom": "Få inlägg i din inkorg utan att skapa ett Mastodon-konto. Avsluta prenumerationen när som helst. För mer information, se vår <a>sekretesspolicy</a>.",
  "email_subscriptions.form.title": "Registrera dig för e-postuppdateringar från {name}",
  "email_subscriptions.submitted.lead": "Kolla din inkorg efter ett e-postmeddelande för att slutföra registreringen för e-postuppdateringar.",
  "email_subscriptions.submitted.title": "Ett steg kvar",
  "email_subscriptions.validation.email.blocked": "Blockerad e-postleverantör",
  "email_subscriptions.validation.email.invalid": "Ogiltig epostadress",
  "embed.instructions": "Bädda in detta inlägg på din webbplats genom att kopiera koden nedan.",
  "embed.preview": "Så här kommer det att se ut:",
  "emoji_button.activity": "Aktivitet",
  "emoji_button.clear": "Rensa",
  "emoji_button.custom": "Anpassad",
  "emoji_button.flags": "Flaggor",
  "emoji_button.food": "Mat & dryck",
  "emoji_button.label": "Lägg till emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Inga matchande emojis hittades",
  "emoji_button.objects": "Objekt",
  "emoji_button.people": "Personer",
  "emoji_button.recent": "Ofta använda",
  "emoji_button.search": "Sök...",
  "emoji_button.search_results": "Sökresultat",
  "emoji_button.symbols": "Symboler",
  "emoji_button.travel": "Resor & platser",
  "empty_column.account_featured.other": "{acct} har inte visat något ännu.",
  "empty_column.account_featured_self.no_collections_button": "Skapa en samling",
  "empty_column.account_featured_self.no_collections_hide_tab": "Dölj denna flik istället",
  "empty_column.account_featured_self.showcase_accounts": "Visa dina favoritkonton",
  "empty_column.account_featured_self.showcase_accounts_desc": "Samlingarna är anpassade listor över konton för att hjälpa andra att upptäcka mer av Fediverse:t.",
  "empty_column.account_featured_unknown.other": "Detta konto har inte presenterat något ännu.",
  "empty_column.account_hides_collections": "Användaren har valt att inte göra denna information tillgänglig",
  "empty_column.account_suspended": "Kontot är avstängt",
  "empty_column.account_timeline": "Inga inlägg här!",
  "empty_column.account_unavailable": "Profilen ej tillgänglig",
  "empty_column.blocks": "Du har ännu ej blockerat några användare.",
  "empty_column.bookmarked_statuses": "Du har inte bokmärkt några inlägg än. När du bokmärker ett inlägg kommer det synas här.",
  "empty_column.collections": "{acct} har ännu inte skapat några samlingar.",
  "empty_column.collections.featured_in": "Du har inte lagts till i några samlingar än.",
  "empty_column.collections.featured_in_undiscoverable": "För att personer ska kunna lägga till dig i samlingar, måste du tillåta att inkluderas i upptäcktsupplevelser från <link>Inställningar> Sekretess och räckvidd</link>",
  "empty_column.collections_self": "Du har inte skapat några samlingar än.",
  "empty_column.community": "Den lokala tidslinjen är tom. Skriv något offentligt för att sätta bollen i rullning!",
  "empty_column.direct": "Du har inga privata omnämnanden. När du skickar eller tar emot ett direktmeddelande kommer det att visas här.",
  "empty_column.disabled_feed": "Detta flöde har inaktiverats av dina serveradministratörer.",
  "empty_column.domain_blocks": "Det finns ännu inga dolda domäner.",
  "empty_column.explore_statuses": "Ingenting är trendigt just nu. Kom tillbaka senare!",
  "empty_column.favourited_statuses": "Du har inga favoritmarkerade inlägg ännu. När du favoritmarkerar ett så kommer det att dyka upp här.",
  "empty_column.favourites": "Ingen har favoritmarkerat detta inlägg än. När någon gör det kommer de synas här.",
  "empty_column.follow_requests": "Du har inga följarförfrågningar än. När du får en kommer den visas här.",
  "empty_column.followed_tags": "Du följer inga hashtaggar ännu. När du gör det kommer de att dyka upp här.",
  "empty_column.hashtag": "Det finns inget i denna hashtag ännu.",
  "empty_column.home": "Din hemma-tidslinje är tom! Följ fler användare för att fylla den.",
  "empty_column.list": "Det finns inget i denna lista än. När listmedlemmar publicerar nya inlägg kommer de synas här.",
  "empty_column.mutes": "Du har ännu inte tystat några användare.",
  "empty_column.notification_requests": "Allt klart! Det finns inget mer här. När du får nya meddelanden visas de här enligt dina inställningar.",
  "empty_column.notifications": "Du har inga meddelanden än. Interagera med andra för att starta konversationen.",
  "empty_column.public": "Det finns inget här! Skriv något offentligt, eller följ manuellt användarna från andra instanser för att fylla på det",
  "empty_state.no_results": "Inga resultat",
  "error.no_hashtag_feed_access": "Gå med eller logga in för att visa och följa denna hashtag.",
  "error.unexpected_crash.explanation": "På grund av en bugg i vår kod eller kompatiblitetsproblem i webbläsaren kan den här sidan inte visas korrekt.",
  "error.unexpected_crash.explanation_addons": "Denna sida kunde inte visas korrekt. Detta beror troligen på ett webbläsartillägg eller ett automatiskt översättningsverktyg.",
  "error.unexpected_crash.next_steps": "Prova att ladda om sidan. Om det inte hjälper kan du försöka använda Mastodon med en annan webbläsare eller app.",
  "error.unexpected_crash.next_steps_addons": "Prova att avaktivera dem och uppdatera sidan. Om detta inte hjälper kan du försöka använda Mastodon med en annan webbläsare eller en app.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiera stacktrace till urklipp",
  "errors.unexpected_crash.report_issue": "Rapportera problem",
  "explore.suggested_follows": "Personer",
  "explore.title": "Trendar",
  "explore.trending_links": "Nyheter",
  "explore.trending_statuses": "Inlägg",
  "explore.trending_tags": "Hashtaggar",
  "featured_carousel.current": "<sr>Inlägg</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural,one {Fäst inlägg} other {Fästa inlägg}}",
  "featured_carousel.slide": "Inlägg {current, number} av {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "På senare tid har du skrivit om {items}. Lägg till dessa som utvalda hashtaggar?",
  "featured_tags.suggestions.add": "Lägg till",
  "featured_tags.suggestions.added": "Hantera dina utvalda hashtaggar när som helst under <link>Redigera profil > Utvalda hashtaggar</link>.",
  "featured_tags.suggestions.dismiss": "Nej tack",
  "filter_modal.added.context_mismatch_explanation": "Denna filterkategori gäller inte för det sammanhang där du har tillgång till det här inlägget. Om du vill att inlägget ska filtreras även i detta sammanhang måste du redigera filtret.",
  "filter_modal.added.context_mismatch_title": "Misspassning av sammanhang!",
  "filter_modal.added.expired_explanation": "Denna filterkategori har utgått, du måste ändra utgångsdatum för att den ska kunna tillämpas.",
  "filter_modal.added.expired_title": "Utgånget filter!",
  "filter_modal.added.review_and_configure": "För att granska och vidare konfigurera denna filterkategorin, gå till {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filterinställningar",
  "filter_modal.added.settings_link": "inställningar",
  "filter_modal.added.short_explanation": "Inlägget har lagts till i följande filterkategori: {title}.",
  "filter_modal.added.title": "Filter tillagt!",
  "filter_modal.select_filter.context_mismatch": "gäller inte för detta sammanhang",
  "filter_modal.select_filter.expired": "utgånget",
  "filter_modal.select_filter.prompt_new": "Ny kategori: {name}",
  "filter_modal.select_filter.search": "Sök eller skapa",
  "filter_modal.select_filter.subtitle": "Använd en befintlig kategori eller skapa en ny",
  "filter_modal.select_filter.title": "Filtrera detta inlägg",
  "filter_modal.title.status": "Filtrera ett inlägg",
  "filter_warning.matches_filter": "Matchar filtret \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "Från {count, plural, =0 {ingen} one {en person} other {# personer}} som du kanske känner",
  "filtered_notifications_banner.title": "Filtrerade aviseringar",
  "firehose.all": "Allt",
  "firehose.local": "Denna server",
  "firehose.remote": "Andra servrar",
  "follow_request.authorize": "Godkänn",
  "follow_request.reject": "Avvisa",
  "follow_requests.unlocked_explanation": "Även om ditt konto inte är låst tror {domain}-personalen att du kanske vill granska dessa följares förfrågningar manuellt.",
  "follow_suggestions.curated_suggestion": "Utvald av personalen",
  "follow_suggestions.dismiss": "Visa inte igen",
  "follow_suggestions.featured_longer": "Handplockad av {domain}-teamet",
  "follow_suggestions.friends_of_friends_longer": "Populärt bland personer du följer",
  "follow_suggestions.hints.featured": "Denna profil är handplockad av {domain}-teamet.",
  "follow_suggestions.hints.friends_of_friends": "Denna profil är populär bland de personer du följer.",
  "follow_suggestions.hints.most_followed": "Denna profil är en av de mest följda på {domain}.",
  "follow_suggestions.hints.most_interactions": "Denna profil har nyligen fått mycket uppmärksamhet på {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Denna profil liknar de profiler som du nyligen har följt.",
  "follow_suggestions.personalized_suggestion": "Personligt förslag",
  "follow_suggestions.popular_suggestion": "Populärt förslag",
  "follow_suggestions.popular_suggestion_longer": "Populärt på {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Liknar profiler du nyligen följde",
  "follow_suggestions.view_all": "Visa alla",
  "follow_suggestions.who_to_follow": "Rekommenderade profiler",
  "followed_tags": "Följda hashtags",
  "followers.hide_other_followers": "Denna användare har valt att inte göra sina andra följare synliga",
  "followers.title": "Följer {name}",
  "following.hide_other_following": "Denna användare har valt att inte göra resten av vilka de följer synliga",
  "following.title": "Följs av {name}",
  "footer.about": "Om",
  "footer.about_mastodon": "Om Mastodon",
  "footer.about_server": "Om {domain}",
  "footer.about_this_server": "Om",
  "footer.directory": "Profilkatalog",
  "footer.get_app": "Skaffa appen",
  "footer.keyboard_shortcuts": "Tangentbordsgenvägar",
  "footer.privacy_policy": "Integritetspolicy",
  "footer.source_code": "Visa källkod",
  "footer.status": "Status",
  "footer.terms_of_service": "Användarvillkor",
  "form_error.blank": "Fältet får inte vara tomt.",
  "form_field.optional": "(valfritt)",
  "getting_started.heading": "Kom igång",
  "hashtag.admin_moderation": "Öppet modereringsgränssnittet för #{name}",
  "hashtag.browse": "Bläddra bland inlägg i #{hashtag}",
  "hashtag.browse_from_account": "Bläddra bland inlägg från @{name} i #{hashtag}",
  "hashtag.column_header.tag_mode.all": "och {additional}",
  "hashtag.column_header.tag_mode.any": "eller {additional}",
  "hashtag.column_header.tag_mode.none": "utan {additional}",
  "hashtag.column_settings.select.no_options_message": "Inga förslag hittades",
  "hashtag.column_settings.select.placeholder": "Ange hashtaggar…",
  "hashtag.column_settings.tag_mode.all": "Alla dessa",
  "hashtag.column_settings.tag_mode.any": "Någon av dessa",
  "hashtag.column_settings.tag_mode.none": "Ingen av dessa",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} deltagare} other {{counter} deltagare}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} inlägg} other {{counter} inlägg}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} inlägg} other {{counter} inlägg}} i dag",
  "hashtag.feature": "Visa på profil",
  "hashtag.follow": "Följ hashtagg",
  "hashtag.mute": "Tysta #{hashtag}",
  "hashtag.unfeature": "Visa inte på profil",
  "hashtag.unfollow": "Avfölj hashtagg",
  "hashtags.and_other": "…och {count, plural, one {# till} other {# till}}",
  "hints.profiles.followers_may_be_missing": "Det kan saknas vissa följare av denna profil.",
  "hints.profiles.follows_may_be_missing": "Det kan saknas vissa följare av denna profil.",
  "hints.profiles.posts_may_be_missing": "Det kan saknas vissa följare för denna profil.",
  "hints.profiles.see_more_followers": "Se fler följare på {domain}",
  "hints.profiles.see_more_follows": "Se fler följare på {domain}",
  "hints.profiles.see_more_posts": "Se fler inlägg på {domain}",
  "home.column_settings.show_quotes": "Visa citat",
  "home.column_settings.show_reblogs": "Visa boostar",
  "home.column_settings.show_replies": "Visa svar",
  "home.hide_announcements": "Dölj notiser",
  "home.pending_critical_update.body": "Uppdatera din Mastodon-server så snart som möjligt!",
  "home.pending_critical_update.link": "Se uppdateringar",
  "home.pending_critical_update.title": "En kritisk säkerhetsuppdatering är tillgänglig!",
  "home.show_announcements": "Visa notiser",
  "ignore_notifications_modal.bots_title": "Ignorera aviseringar från botar?",
  "ignore_notifications_modal.disclaimer": "Mastodon kan inte informera användarna om att du har ignorerat deras meddelanden. Ignorering av aviseringar kommer inte att stoppa själva meddelandena från att skickas.",
  "ignore_notifications_modal.filter_instead": "Filtrera istället",
  "ignore_notifications_modal.filter_to_act_users": "Du kommer fortfarande att kunna acceptera, avvisa eller rapportera användare",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrering hjälper till att undvika eventuell förvirring",
  "ignore_notifications_modal.filter_to_review_separately": "Du kan granska filtrerade aviseringar separat",
  "ignore_notifications_modal.ignore": "Ignorera notifikationer",
  "ignore_notifications_modal.limited_accounts_title": "Vill du ignorera aviseringar från modererade konton?",
  "ignore_notifications_modal.new_accounts_title": "Vill du ignorera aviseringar från nya konton?",
  "ignore_notifications_modal.not_followers_title": "Vill du ignorera aviseringar från personer som inte följer dig?",
  "ignore_notifications_modal.not_following_title": "Vill du blockera aviseringar från personer som du inte följer dig?",
  "ignore_notifications_modal.private_mentions_title": "Vill du ignorera aviseringar från oombedda privata omnämnanden?",
  "info_button.label": "Hjälp",
  "info_button.what_is_alt_text": "<h1>Vad är alt-text?</h1> <p>alt-text ger bildbeskrivningar för personer med synnedsättning, anslutningar med låg bandbredd eller de som söker extra sammanhang.</p> <p>Du kan förbättra tillgängligheten och förståelsen för alla genom att skriva en tydlig, koncis och objektiv alt-text.</p> <ul> <li>Fånga viktiga element</li> <li>Sammanfatta text i bilder</li> <li>Använd vanlig meningsstruktur</li> <li>Undvik överflödig information</li> <li>Fokus på trender och viktiga resultat i komplexa bilder (som diagram eller kartor)</li> </ul>",
  "interaction_modal.action": "För att interagera med {name}s inlägg måste du logga in på ditt konto på vilken Mastodon-server du än använder.",
  "interaction_modal.action_follow": "För att följa {name} måste du logga in på ditt konto för den Mastodon-server du använder.",
  "interaction_modal.go": "Vidare",
  "interaction_modal.no_account_yet": "Har du inget konto än?",
  "interaction_modal.on_another_server": "På en annan server",
  "interaction_modal.on_this_server": "På denna server",
  "interaction_modal.title": "Logga in för att fortsätta",
  "interaction_modal.username_prompt": "T.ex. {example}",
  "intervals.full.days": "{number, plural, one {# dag} other {# dagar}}",
  "intervals.full.hours": "{number, plural, one {# timme} other {# timmar}}",
  "intervals.full.minutes": "{number, plural, one {# minut} other {# minuter}}",
  "keyboard_shortcuts.back": "Gå bakåt",
  "keyboard_shortcuts.blocked": "Öppna listan över blockerade användare",
  "keyboard_shortcuts.boost": "Boosta inlägg",
  "keyboard_shortcuts.column": "Fokusera kolumn",
  "keyboard_shortcuts.compose": "Fokusera skrivfältet",
  "keyboard_shortcuts.description": "Beskrivning",
  "keyboard_shortcuts.direct": "Öppna kolumnen med privata omnämnanden",
  "keyboard_shortcuts.down": "Flytta ner i listan",
  "keyboard_shortcuts.enter": "Öppna inlägg",
  "keyboard_shortcuts.explore": "Öppna trendande tidslinje",
  "keyboard_shortcuts.favourite": "Favoritmarkera inlägg",
  "keyboard_shortcuts.favourites": "Öppna favoritlistan",
  "keyboard_shortcuts.federated": "Öppna federerad tidslinje",
  "keyboard_shortcuts.heading": "Tangentbordsgenvägar",
  "keyboard_shortcuts.home": "Öppna Hemtidslinjen",
  "keyboard_shortcuts.hotkey": "Kommando",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backsteg",
  "keyboard_shortcuts.keys.enter": "Retur",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Sida ned",
  "keyboard_shortcuts.keys.page_up": "Sida upp",
  "keyboard_shortcuts.legend": "Visa denna översikt",
  "keyboard_shortcuts.load_more": "Fokusera \"Ladda mer\"-knappen",
  "keyboard_shortcuts.local": "Öppna lokal tidslinje",
  "keyboard_shortcuts.mention": "Nämna skaparen",
  "keyboard_shortcuts.muted": "Öppna listan över tystade användare",
  "keyboard_shortcuts.my_profile": "Öppna din profil",
  "keyboard_shortcuts.notifications": "Öppna meddelanden",
  "keyboard_shortcuts.open_media": "Öppna media",
  "keyboard_shortcuts.pinned": "Öppna listan över fästa inlägg",
  "keyboard_shortcuts.profile": "Öppna författarens profil",
  "keyboard_shortcuts.quote": "Citera inlägg",
  "keyboard_shortcuts.reply": "Svara på inlägg",
  "keyboard_shortcuts.requests": "Öppna följförfrågningar",
  "keyboard_shortcuts.search": "Fokusera sökfältet",
  "keyboard_shortcuts.spoilers": "Visa/dölja CW-fält",
  "keyboard_shortcuts.start": "Öppna \"Kom igång\"-kolumnen",
  "keyboard_shortcuts.toggle_hidden": "Visa/gömma text bakom CW",
  "keyboard_shortcuts.toggle_sensitivity": "Visa/gömma media",
  "keyboard_shortcuts.toot": "Starta nytt inlägg",
  "keyboard_shortcuts.top": "Flytta till början av listan",
  "keyboard_shortcuts.translate": "Översätt ett inlägg",
  "keyboard_shortcuts.unfocus": "Avfokusera skrivfält/sökfält",
  "keyboard_shortcuts.up": "Flytta uppåt i listan",
  "learn_more_link.got_it": "Jag förstår",
  "learn_more_link.learn_more": "Läs mer",
  "lightbox.close": "Stäng",
  "lightbox.next": "Nästa",
  "lightbox.previous": "Tidigare",
  "lightbox.zoom_in": "Zooma till faktisk storlek",
  "lightbox.zoom_out": "Zooma för att passa",
  "limited_account_hint.action": "Visa profil ändå",
  "limited_account_hint.title": "Denna profil eller server har dolts av {domain}s moderatorer.",
  "link_preview.author": "Av {name}",
  "link_preview.more_from_author": "Mer från {name}",
  "link_preview.shares": "{count, plural, one {{counter} inlägg} other {{counter} inlägg}}",
  "lists.add_member": "Lägg till",
  "lists.add_to_list": "Lägg till i lista",
  "lists.add_to_lists": "Lägg till {name} i listor",
  "lists.create": "Skapa",
  "lists.create_a_list_to_organize": "Skapa en ny lista för att organisera ditt hemtidlinje",
  "lists.create_list": "Skapa lista",
  "lists.delete": "Radera lista",
  "lists.done": "Klar",
  "lists.edit": "Redigera lista",
  "lists.exclusive": "Dölj medlemmar i Hem flödet",
  "lists.exclusive_hint": "Om någon är med på den här listan, göm dem i ditt Hemtidlinje för att undvika att se deras inlägg två gånger.",
  "lists.find_users_to_add": "Hitta användare att lägga till",
  "lists.list_members_count": "{count, plural, one {# medlem} other {# medlemmar}}",
  "lists.list_name": "Listnamn",
  "lists.new_list_name": "Nytt listnamn",
  "lists.no_lists_yet": "Ännu inga listor.",
  "lists.no_members_yet": "Inga medlemmar ännu.",
  "lists.no_results_found": "Inga resultat hittades.",
  "lists.remove_member": "Ta bort",
  "lists.replies_policy.followed": "Alla användare som följs",
  "lists.replies_policy.list": "Medlemmar i listan",
  "lists.replies_policy.none": "Ingen",
  "lists.save": "Spara",
  "lists.search": "Sök",
  "lists.show_replies_to": "Inkludera svar från listmedlemmar till",
  "load_pending": "{count, plural, one {# nytt objekt} other {# nya objekt}}",
  "loading_indicator.label": "Laddar…",
  "media_gallery.hide": "Dölj",
  "moved_to_account_banner.text": "Ditt konto {disabledAccount} är för närvarande inaktiverat eftersom du flyttat till {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Dölj från aviseringslistan",
  "mute_modal.hide_options": "Dölj alternativ",
  "mute_modal.indefinite": "Tills jag avtystar dem",
  "mute_modal.show_options": "Visa alternativ",
  "mute_modal.they_can_mention_and_follow": "De kan nämna och följa dig, men du ser dem inte.",
  "mute_modal.they_wont_know": "De vet inte att de har blivit tysta.",
  "mute_modal.title": "Tysta användare?",
  "mute_modal.you_wont_see_mentions": "Du kommer inte att se inlägg som nämner dem.",
  "mute_modal.you_wont_see_posts": "De kan fortfarande se dina inlägg, men du kan inte se deras.",
  "navigation_bar.about": "Om",
  "navigation_bar.account_settings": "Lösenord och säkerhet",
  "navigation_bar.administration": "Administration",
  "navigation_bar.advanced_interface": "Öppna i avancerat webbgränssnitt",
  "navigation_bar.automated_deletion": "Automatisk radering av inlägg",
  "navigation_bar.blocks": "Blockerade användare",
  "navigation_bar.bookmarks": "Bokmärken",
  "navigation_bar.collections": "Samlingar",
  "navigation_bar.direct": "Privata omnämnande",
  "navigation_bar.domain_blocks": "Dolda domäner",
  "navigation_bar.favourites": "Favoriter",
  "navigation_bar.filters": "Tystade ord",
  "navigation_bar.follow_requests": "Följförfrågningar",
  "navigation_bar.followed_tags": "Följda hashtaggar",
  "navigation_bar.follows_and_followers": "Följer och följare",
  "navigation_bar.import_export": "Importera och exportera",
  "navigation_bar.lists": "Listor",
  "navigation_bar.live_feed_local": "Direkt flöde (lokalt)",
  "navigation_bar.live_feed_public": "Direkt flöde (publikt)",
  "navigation_bar.logout": "Logga ut",
  "navigation_bar.main": "Allmänt",
  "navigation_bar.moderation": "Moderering",
  "navigation_bar.more": "Fler",
  "navigation_bar.mutes": "Tystade användare",
  "navigation_bar.opened_in_classic_interface": "Inlägg, konton och andra specifika sidor öppnas som standard i det klassiska webbgränssnittet.",
  "navigation_bar.preferences": "Inställningar",
  "navigation_bar.privacy_and_reach": "Integritet och räckvidd",
  "navigation_bar.search": "Sök",
  "navigation_bar.search_trends": "Sök / Trendar",
  "navigation_panel.collapse_followed_tags": "Minska menyn för följda fyrkantstaggar",
  "navigation_panel.collapse_lists": "Komprimera listmenyn",
  "navigation_panel.expand_followed_tags": "Expandera menyn för följda fyrkantstaggar",
  "navigation_panel.expand_lists": "Expandera listmeny",
  "not_signed_in_indicator.not_signed_in": "Du behöver logga in för att få åtkomst till denna resurs.",
  "notification.added_to_collection": "{name} lade till dig i en samling",
  "notification.admin.report": "{name} rapporterade {target}",
  "notification.admin.report_account": "{name} rapporterade {count, plural, one {ett inlägg} other {# inlägg}} från {target} för {category}",
  "notification.admin.report_account_other": "{name} rapporterade {count, plural, one {ett inlägg} other {# inlägg}} från {target}",
  "notification.admin.report_statuses": "{name} rapporterade {target} för {category}",
  "notification.admin.report_statuses_other": "{name} rapporterade {target}",
  "notification.admin.sign_up": "{name} registrerade sig",
  "notification.admin.sign_up.name_and_others": "{name} och {count, plural, one {# en annan} other {# andra}} har registrerat sig",
  "notification.annual_report.message": "Din {year} #Wrapstodon väntar! Upptäck ditt års höjdpunkter och minnesvärda stunder på Mastodon!",
  "notification.annual_report.view": "Visa #Wrapstodon",
  "notification.collection_update": "{name} redigerade en samling du är med i",
  "notification.favourite": "{name} favoritmarkerade ditt inlägg",
  "notification.favourite.name_and_others_with_link": "{name} och <a>{count, plural, one {# annan} other {# andra}}</a> favoritmarkerade ditt inlägg",
  "notification.favourite_pm": "{name} favoritmarkerade ditt privata omnämnande",
  "notification.favourite_pm.name_and_others_with_link": "{name} och <a>{count, plural, one {# annan} other {# andra}}</a> favoritmarkerade ditt privata omnämnande",
  "notification.follow": "{name} följer dig",
  "notification.follow.name_and_others": "{name} och <a>{count, plural, one {# annan} other {# andra}}</a> följer dig",
  "notification.follow_request": "{name} har begärt att följa dig",
  "notification.follow_request.name_and_others": "{name} och {count, plural, one {# en annan} other {# andra}} har bett att följa dig",
  "notification.label.mention": "Nämn",
  "notification.label.private_mention": "Privat omnämnande",
  "notification.label.private_reply": "Privata svar",
  "notification.label.quote": "{name} citerade ditt inlägg",
  "notification.label.reply": "Svar",
  "notification.mention": "Nämn",
  "notification.mentioned_you": "{name} nämnde dig",
  "notification.moderation-warning.learn_more": "Läs mer",
  "notification.moderation_warning": "Du har fått en moderationsvarning",
  "notification.moderation_warning.action_delete_statuses": "Några av dina inlägg har tagits bort.",
  "notification.moderation_warning.action_disable": "Ditt konto har inaktiverats.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Några av dina inlägg har markerats som känsliga.",
  "notification.moderation_warning.action_none": "Ditt konto har mottagit en modereringsvarning.",
  "notification.moderation_warning.action_sensitive": "Dina inlägg kommer markeras som känsliga från och med nu.",
  "notification.moderation_warning.action_silence": "Ditt konto har begränsats.",
  "notification.moderation_warning.action_suspend": "Ditt konto har stängts av.",
  "notification.own_poll": "Din röstning har avslutats",
  "notification.poll": "En enkät som du röstat i har avslutats",
  "notification.quoted_update": "{name} redigerade ett inlägg du har citerat",
  "notification.reblog": "{name} boostade ditt inlägg",
  "notification.reblog.name_and_others_with_link": "{name} och <a>{count, plural, one {# annan} other {# andra}}</a> boostade ditt inlägg",
  "notification.relationships_severance_event": "Förlorade kontakter med {name}",
  "notification.relationships_severance_event.account_suspension": "En administratör från {from} har stängt av {target}, vilket innebär att du inte längre kan ta emot uppdateringar från dem eller interagera med dem.",
  "notification.relationships_severance_event.domain_block": "En administratör från {from} har blockerat {target}, inklusive {followersCount} av dina följare och {followingCount, plural, one {# konto} other {# konton}} du följer.",
  "notification.relationships_severance_event.learn_more": "Läs mer",
  "notification.relationships_severance_event.user_domain_block": "Du har blockerat {target} och tar därmed bort {followersCount} av dina följare samt {followingCount, plural, one {# konto} other {# konton}} du följer.",
  "notification.status": "{name} publicerade just ett inlägg",
  "notification.update": "{name} redigerade ett inlägg",
  "notification_requests.accept": "Godkänn",
  "notification_requests.accept_multiple": "{count, plural, one {Acceptera # förfrågan…} other {Acceptera # förfrågningar…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Acceptera förfrågan} other {Acceptera förfrågningar}}",
  "notification_requests.confirm_accept_multiple.message": "Du håller på att acceptera {count, plural, one {en förfrågan} other {# förfrågningar}} om avisering. Är du säker på att du vill fortsätta?",
  "notification_requests.confirm_accept_multiple.title": "Vill du acceptera aviseringsförfrågningar?",
  "notification_requests.confirm_dismiss_multiple.button": "Avvisa {count, plural, one {# förfrågan} other {# förfrågningar}}",
  "notification_requests.confirm_dismiss_multiple.message": "Du håller på att avfärda {count, plural, one {en aviseringsförfrågan} other {# aviseringsförfrågningar}}. Du kommer inte enkelt att kunna komma åt {count, plural, one {den} other {dem}} igen. Är du säker på att du vill fortsätta?",
  "notification_requests.confirm_dismiss_multiple.title": "Vill du acceptera aviseringsförfrågningar?",
  "notification_requests.dismiss": "Avfärda",
  "notification_requests.dismiss_multiple": "Avvisa {count, plural, one {# förfrågan} other {# förfrågningar}}...",
  "notification_requests.edit_selection": "Redigera",
  "notification_requests.exit_selection": "Klar",
  "notification_requests.explainer_for_limited_account": "Aviseringar från detta konto har filtrerats eftersom kontot har begränsats av en moderator.",
  "notification_requests.explainer_for_limited_remote_account": "Aviseringar från detta konto eller denna server har filtrerats eftersom kontot har begränsats av en moderator.",
  "notification_requests.maximize": "Maximera",
  "notification_requests.minimize_banner": "Minimera ruta för filtrerade aviseringar",
  "notification_requests.notifications_from": "Aviseringar från {name}",
  "notification_requests.title": "Filtrerade meddelanden",
  "notification_requests.view": "Visa aviseringar",
  "notifications.clear": "Rensa aviseringar",
  "notifications.clear_confirmation": "Är du säker på att du vill rensa alla dina aviseringar permanent?",
  "notifications.clear_title": "Rensa aviseringar?",
  "notifications.column_settings.admin.report": "Nya rapporter:",
  "notifications.column_settings.admin.sign_up": "Nya registreringar:",
  "notifications.column_settings.alert": "Skrivbordsaviseringar",
  "notifications.column_settings.collections": "Samlingar:",
  "notifications.column_settings.favourite": "Favoriter:",
  "notifications.column_settings.filter_bar.advanced": "Visa alla kategorier",
  "notifications.column_settings.filter_bar.category": "Snabbfilter",
  "notifications.column_settings.follow": "Nya följare:",
  "notifications.column_settings.follow_request": "Ny följ-förfrågan:",
  "notifications.column_settings.group": "Gruppera",
  "notifications.column_settings.mention": "Omnämningar:",
  "notifications.column_settings.poll": "Omröstningsresultat:",
  "notifications.column_settings.push": "Push-aviseringar",
  "notifications.column_settings.quote": "Citerat:",
  "notifications.column_settings.reblog": "Boostar:",
  "notifications.column_settings.show": "Visa i kolumnen",
  "notifications.column_settings.sound": "Spela upp ljud",
  "notifications.column_settings.status": "Nya inlägg:",
  "notifications.column_settings.unread_notifications.category": "Olästa aviseringar",
  "notifications.column_settings.unread_notifications.highlight": "Markera olästa aviseringar",
  "notifications.column_settings.update": "Redigeringar:",
  "notifications.filter.all": "Alla",
  "notifications.filter.boosts": "Boostar",
  "notifications.filter.collections": "Samlingar",
  "notifications.filter.favourites": "Favoriter",
  "notifications.filter.follows": "Följer",
  "notifications.filter.mentions": "Omnämningar",
  "notifications.filter.polls": "Omröstningsresultat",
  "notifications.filter.statuses": "Uppdateringar från personer som du följer",
  "notifications.grant_permission": "Godkänn åtkomst.",
  "notifications.group": "{count} aviseringar",
  "notifications.mark_as_read": "Markera varje avisering som läst",
  "notifications.permission_denied": "Skrivbordsaviseringar är otillgängliga på grund av tidigare nekade förfrågningar om behörighet i webbläsaren",
  "notifications.permission_denied_alert": "Skrivbordsaviseringar kan inte aktiveras, eftersom att webbläsarens behörighet har nekats innan",
  "notifications.permission_required": "Skrivbordsaviseringar är otillgängliga eftersom att rättigheten som krävs inte har godkänts.",
  "notifications.policy.accept": "Acceptera",
  "notifications.policy.accept_hint": "Visa bland aviseringar",
  "notifications.policy.drop": "Ignorera",
  "notifications.policy.drop_hint": "Skicka ut i tomrummet för aldrig synas till igen",
  "notifications.policy.filter": "Filtrera",
  "notifications.policy.filter_bots_hint": "Konton markerade som automatiserade",
  "notifications.policy.filter_bots_title": "Botar",
  "notifications.policy.filter_hint": "Skicka till inkorgen för filtrerade aviserings",
  "notifications.policy.filter_limited_accounts_hint": "Begränsade av servermoderatorer",
  "notifications.policy.filter_limited_accounts_title": "Modererade konton",
  "notifications.policy.filter_new_accounts.hint": "Skapade under de senaste {days, plural, one {# dagen} other {# dagarna}}",
  "notifications.policy.filter_new_accounts_title": "Nya konton",
  "notifications.policy.filter_not_followers_hint": "Inklusive personer som har följt dig kortare än {days, plural, one {en dag} other {# dagar}}",
  "notifications.policy.filter_not_followers_title": "Personer som inte följer dig",
  "notifications.policy.filter_not_following_hint": "Tills du manuellt godkänner dem",
  "notifications.policy.filter_not_following_title": "Personer du inte följer",
  "notifications.policy.filter_private_mentions_hint": "Filtrerat om det inte är som svar på ditt eget omnämnande eller om du följer avsändaren",
  "notifications.policy.filter_private_mentions_title": "Oombedda privata omnämnanden",
  "notifications.policy.title": "Hantera aviseringar från…",
  "notifications_permission_banner.enable": "Aktivera skrivbordsaviseringar",
  "notifications_permission_banner.how_to_control": "För att ta emot aviseringar när Mastodon inte är öppet, aktivera skrivbordsaviseringar. När de är aktiverade kan du styra exakt vilka typer av interaktioner som aviseras via {icon} -knappen ovan.",
  "notifications_permission_banner.title": "Missa aldrig något",
  "onboarding.follows.back": "Tillbaka",
  "onboarding.follows.empty": "Tyvärr kan inga resultat visas just nu. Du kan prova att använda sökfunktionen eller utforska sidan för att hitta personer att följa, eller försök igen senare.",
  "onboarding.follows.next": "Nästa: Ställ in din profil",
  "onboarding.follows.search": "Sök",
  "onboarding.follows.title": "Följ människor för att komma igång",
  "onboarding.profile.discoverable": "Gör min profil upptäckbar",
  "onboarding.profile.discoverable_hint": "När du väljer att vara upptäckbar på Mastodon kan dina inlägg visas i sök- och trendresultat, och din profil kan föreslås för personer med liknande intressen som du.",
  "onboarding.profile.display_name": "Visningsnamn",
  "onboarding.profile.display_name_hint": "Fullständigt namn eller ditt roliga namn…",
  "onboarding.profile.finish": "Avsluta",
  "onboarding.profile.note": "Biografi",
  "onboarding.profile.note_hint": "Du kan @nämna andra personer eller #hashtags…",
  "onboarding.profile.title": "Konfiguration av profil",
  "onboarding.profile.upload_avatar": "Ladda upp profilbild",
  "onboarding.profile.upload_header": "Ladda upp profilbanner",
  "password_confirmation.exceeds_maxlength": "Lösenordsbekräftelsen överskrider den maximala längden på lösenordet",
  "password_confirmation.mismatching": "Lösenordsbekräftelsen matchar inte",
  "picture_in_picture.restore": "Lägg tillbaka det",
  "poll.closed": "Stängd",
  "poll.refresh": "Ladda om",
  "poll.reveal": "Visa resultat",
  "poll.total_people": "{count, plural, one {# person} other {# personer}}",
  "poll.total_votes": "{count, plural, one {# röst} other {# röster}}",
  "poll.vote": "Rösta",
  "poll.voted": "Du röstade för detta svar",
  "poll.votes": "{votes, plural, one {# röst} other {# röster}}",
  "poll_button.add_poll": "Lägg till en omröstning",
  "poll_button.remove_poll": "Ta bort omröstning",
  "privacy.change": "Ändra inläggsintegritet",
  "privacy.direct.long": "Alla som nämns i inlägget",
  "privacy.direct.short": "Privat omnämnande",
  "privacy.private.long": "Endast dina följare",
  "privacy.private.short": "Följare",
  "privacy.public.long": "Alla på och utanför Mastodon",
  "privacy.public.short": "Offentlig",
  "privacy.quote.anyone": "{visibility}, citat tillåtna",
  "privacy.quote.disabled": "{visibility}, citat inaktiverade",
  "privacy.quote.limited": "{visibility}, citat begränsade",
  "privacy.unlisted.additional": "Detta fungerar precis som offentlig, förutom att inlägget inte visas i liveflöden eller hashtaggar, utforska eller Mastodon-sökning, även om du har valt detta för hela kontot.",
  "privacy.unlisted.long": "Dold från Mastodon-sökresultat, trendar och offentliga tidslinjer",
  "privacy.unlisted.short": "Offentlig (begränsad)",
  "privacy_policy.last_updated": "Senast uppdaterad {date}",
  "privacy_policy.title": "Integritetspolicy",
  "quote_error.edit": "Citat kan inte läggas till när du redigerar ett inlägg.",
  "quote_error.poll": "Citat är inte tillåtet med omröstningar.",
  "quote_error.private_mentions": "Citering är inte tillåtet med direkta omnämnanden.",
  "quote_error.quote": "Endast ett citat åt gången är tillåtet.",
  "quote_error.unauthorized": "Du har inte behörighet att citera detta inlägg.",
  "quote_error.upload": "Citering är inte tillåtet med mediebilagor.",
  "recommended": "Rekommenderas",
  "refresh": "Läs om",
  "regeneration_indicator.please_stand_by": "Vänligen vänta.",
  "regeneration_indicator.preparing_your_home_feed": "Förbereder ditt hemflöde…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dag} other {# dagar}} sedan",
  "relative_time.full.hours": "{number, plural, one {# timme} other {# timmar}} sedan",
  "relative_time.full.just_now": "just nu",
  "relative_time.full.minutes": "{number, plural, one {# minut} other {# minuter}} sedan",
  "relative_time.full.seconds": "{number, plural, one {# sekund} other {# sekunder}} sedan",
  "relative_time.hours": "{number}tim",
  "relative_time.just_now": "nu",
  "relative_time.minutes": "{number}min",
  "relative_time.seconds": "{number}sek",
  "relative_time.today": "idag",
  "remove_quote_hint.button_label": "Jag förstår",
  "remove_quote_hint.message": "Du kan göra det från {icon} alternativmenyn.",
  "remove_quote_hint.title": "Vill du ta bort ditt citerade inlägg?",
  "reply_indicator.attachments": "{count, plural, one {# bilaga} other {# bilagor}}",
  "reply_indicator.cancel": "Ångra",
  "reply_indicator.poll": "Omröstning",
  "report.block": "Blockera",
  "report.block_explanation": "Du kommer inte se hens inlägg. Hen kommer inte kunna se dina inlägg eller följa dig. Hen kommer kunna se att hen är blockerad.",
  "report.categories.legal": "Juridisk",
  "report.categories.other": "Övrigt",
  "report.categories.spam": "Skräppost",
  "report.categories.violation": "Innehåll bryter mot en eller flera serverregler",
  "report.category.subtitle": "Välj den bästa träffen",
  "report.category.title_account": "Berätta för oss vad som pågår med denna profil",
  "report.category.title_collection": "Berätta för oss vad som pågår med denna samling",
  "report.category.title_status": "Berätta för oss vad som pågår med det här inlägget",
  "report.close": "Färdig",
  "report.comment.title": "Finns det något annat vi borde veta?",
  "report.forward": "Vidarebefordra till {target}",
  "report.forward_hint": "Kontot är från en annan server. Skicka även en anonymiserad kopia av anmälan dit?",
  "report.mute": "Tysta",
  "report.mute_explanation": "Du kommer inte se hens inlägg. Hen kan fortfarande följa dig och se dina inlägg. Hen kommer inte veta att hen är tystad.",
  "report.next": "Nästa",
  "report.placeholder": "Ytterligare kommentarer",
  "report.reasons.dislike": "Jag tycker inte om det",
  "report.reasons.dislike_description": "Det är inget som du vill se",
  "report.reasons.legal": "Det är olagligt",
  "report.reasons.legal_description": "Du tror att det bryter mot lagen i ditt eller serverns land",
  "report.reasons.other": "Det är något annat",
  "report.reasons.other_description": "Problemet passar inte in i andra kategorier",
  "report.reasons.spam": "Det är skräppost",
  "report.reasons.spam_description": "Skadliga länkar, bedrägligt beteende eller repetitiva svar",
  "report.reasons.violation": "Det bryter mot serverns regler",
  "report.reasons.violation_description": "Du är medveten om att det bryter mot specifika regler",
  "report.rules.subtitle": "Välj alla som stämmer",
  "report.rules.title": "Vilka regler överträds?",
  "report.statuses.subtitle": "Välj alla som stämmer",
  "report.statuses.title": "Finns det några inlägg som stöder denna rapport?",
  "report.submission_error": "Rapporten kunde inte skickas",
  "report.submission_error_details": "Kontrollera din nätverksanslutning och försök igen senare.",
  "report.submit": "Skicka",
  "report.target": "Rapporterar {target}",
  "report.thanks.take_action": "Här är dina alternativ för att bestämma vad du ser på Mastodon:",
  "report.thanks.take_action_actionable": "Medan vi granskar detta kan du vidta åtgärder mot {name}:",
  "report.thanks.title": "Vill du inte se det här?",
  "report.thanks.title_actionable": "Tack för att du rapporterar, vi kommer att titta på detta.",
  "report.unfollow": "Sluta följ @{name}",
  "report.unfollow_explanation": "Du följer detta konto. Avfölj det för att inte se dess inlägg i ditt hemflöde.",
  "report_notification.attached_statuses": "bifogade {count, plural, one {{count} inlägg} other {{count} inlägg}}",
  "report_notification.categories.legal": "Rättsligt",
  "report_notification.categories.legal_sentence": "olagligt innehåll",
  "report_notification.categories.other": "Övrigt",
  "report_notification.categories.other_sentence": "övrigt",
  "report_notification.categories.spam": "Skräppost",
  "report_notification.categories.spam_sentence": "skräppost",
  "report_notification.categories.violation": "Regelöverträdelse",
  "report_notification.categories.violation_sentence": "regelöverträdelse",
  "report_notification.open": "Öppna rapport",
  "search.clear": "Rensa sökning",
  "search.no_recent_searches": "Inga sökningar nyligen",
  "search.placeholder": "Sök",
  "search.quick_action.account_search": "Profiler som matchar {x}",
  "search.quick_action.go_to_account": "Gå till profil {x}",
  "search.quick_action.go_to_hashtag": "Gå till hashtag {x}",
  "search.quick_action.open_url": "Öppna länk i Mastodon",
  "search.quick_action.status_search": "Inlägg som matchar {x}",
  "search.search_or_paste": "Sök eller klistra in URL",
  "search_popout.full_text_search_disabled_message": "Inte tillgänglig på {domain}.",
  "search_popout.full_text_search_logged_out_message": "Endast tillgängligt när du är inloggad.",
  "search_popout.language_code": "ISO språkkod",
  "search_popout.options": "Sökalternativ",
  "search_popout.quick_actions": "Snabbåtgärder",
  "search_popout.recent": "Senaste sökningarna",
  "search_popout.specific_date": "specifikt datum",
  "search_popout.user": "användare",
  "search_results.accounts": "Profiler",
  "search_results.all": "Alla",
  "search_results.collections": "Samlingar",
  "search_results.hashtags": "Hashtaggar",
  "search_results.no_results": "Inga resultat.",
  "search_results.no_search_yet": "Prova att söka efter inlägg, profiler eller hashtags.",
  "search_results.see_all": "Visa alla",
  "search_results.statuses": "Inlägg",
  "search_results.title": "Sök efter \"{q}\"",
  "server_banner.about_active_users": "Personer som använt denna server de senaste 30 dagarna (månatligt aktiva användare)",
  "server_banner.active_users": "aktiva användare",
  "server_banner.administered_by": "Administrerad av:",
  "server_banner.is_one_of_many": "{domain} är en av de många oberoende Mastodon-servrar som du kan använda för att delta i Fediversen.",
  "server_banner.more_about_this_server": "Mer om denna server",
  "server_banner.server_stats": "Serverstatistik:",
  "sign_in_banner.create_account": "Skapa konto",
  "sign_in_banner.follow_anyone": "Följ vem som helst över Fediversum och se allt i kronologisk ordning. Inga algoritmer, annonser eller klickbeten i sikte.",
  "sign_in_banner.mastodon_is": "Mastodon är det bästa sättet att hänga med i vad som händer.",
  "sign_in_banner.sign_in": "Logga in",
  "sign_in_banner.sso_redirect": "Logga in eller registrera dig",
  "skip_links.hotkey": "<span>Snabbtangent</span> {hotkey}",
  "skip_links.skip_to_content": "Hoppa över till huvudinnehållet",
  "skip_links.skip_to_navigation": "Hoppa till huvudnavigering",
  "status.admin_account": "Öppet modereringsgränssnitt för @{name}",
  "status.admin_domain": "Öppet modereringsgränssnitt för @{domain}",
  "status.admin_status": "Öppna detta inlägg i modereringsgränssnittet",
  "status.all_disabled": "Boostar och citat är inaktiverade",
  "status.block": "Blockera @{name}",
  "status.bookmark": "Bokmärk",
  "status.cancel_reblog_private": "Sluta boosta",
  "status.cannot_edit": "Du får inte redigera det här inlägget",
  "status.cannot_quote": "Du har inte tillåtelse att citera detta inlägg",
  "status.cannot_reblog": "Detta inlägg kan inte boostas",
  "status.contains_quote": "Innehåller citat",
  "status.context.loading": "Laddar fler svar",
  "status.context.loading_error": "Kunde inte ladda nya svar",
  "status.context.loading_success": "Nya svar laddade",
  "status.context.more_replies_found": "Fler svar hittades",
  "status.context.retry": "Försök igen",
  "status.context.show": "Visa",
  "status.continued_thread": "Fortsatt tråd",
  "status.copy": "Kopiera inläggslänk",
  "status.delete": "Radera",
  "status.delete.success": "Inlägg borttaget",
  "status.detailed_status": "Detaljerad samtalsvy",
  "status.direct": "Omnämn @{name} privat",
  "status.direct_indicator": "Privat omnämnande",
  "status.edit": "Redigera",
  "status.edited": "Senast ändrad {date}",
  "status.edited_x_times": "Redigerad {count, plural, one {{count} gång} other {{count} gånger}}",
  "status.embed": "Hämta kod för inbäddning",
  "status.favourite": "Favoritmarkera",
  "status.favourites_count": "{count, plural, one {{counter} favorit} other {{counter} favoriter}}",
  "status.filter": "Filtrera detta inlägg",
  "status.history.created": "{name} skapade {date}",
  "status.history.edited": "{name} redigerade {date}",
  "status.load_more": "Ladda fler",
  "status.media.open": "Klicka för att öppna",
  "status.media.show": "Klicka för att visa",
  "status.media_hidden": "Media dolt",
  "status.mention": "Omnämn @{name}",
  "status.more": "Mer",
  "status.mute": "Tysta @{name}",
  "status.mute_conversation": "Tysta konversation",
  "status.not_quoted": "Du är inte citerad i detta inlägg",
  "status.open": "Utvidga detta inlägg",
  "status.pin": "Fäst i profil",
  "status.public_only": "Detta inlägg är privat",
  "status.quote": "Citera ",
  "status.quote.cancel": "Återkalla citering",
  "status.quote_error.blocked_account_hint.title": "Detta inlägg är dolt eftersom du har blockerat @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Detta inlägg är dolt eftersom du har blockerat {domain}.",
  "status.quote_error.filtered": "Dolt på grund av ett av dina filter",
  "status.quote_error.limited_account_hint.action": "Visa ändå",
  "status.quote_error.limited_account_hint.title": "Detta konto har dolts av {domain}s moderatorer.",
  "status.quote_error.muted_account_hint.title": "Detta inlägg är dolt eftersom du har tystat @{name}.",
  "status.quote_error.not_available": "Inlägg ej tillgängligt",
  "status.quote_error.pending_approval": "Väntande inlägg",
  "status.quote_error.pending_approval_popout.body": "På Mastodon kan du styra om någon kan citera dig. Det här inlägget väntar medan vi får den ursprungliga författarens godkännande.",
  "status.quote_error.revoked": "Inlägg borttaget av författaren",
  "status.quote_followers_only": "Detta inlägg kan bara citeras av följare",
  "status.quote_manual_review": "Författaren kommer att granska manuellt",
  "status.quote_noun": "Citat",
  "status.quote_policy_change": "Ändra vem som kan citera",
  "status.quote_post_author": "Citerade ett inlägg av @{name}",
  "status.quote_private": "Privata inlägg kan inte citeras",
  "status.quotes.empty": "Ingen har citerat detta inlägg än. När någon gör det kommer det att synas här.",
  "status.quotes.local_other_disclaimer": "Citat som avvisats av författaren kommer inte att visas.",
  "status.quotes.remote_other_disclaimer": "Endast citat från {domain} är garanterade att visas här. Citat som avvisats av författaren kommer inte att visas.",
  "status.quotes_count": "{count, plural, one {{counter} citat} other {{counter} citat}}",
  "status.read_more": "Läs mer",
  "status.reblog": "Boosta",
  "status.reblog_or_quote": "Boosta eller citera",
  "status.reblog_private": "Dela igen med dina följare",
  "status.reblogged_by": "{name} boostade",
  "status.reblogs.empty": "Ingen har boostat detta inlägg än. När någon gör det kommer de synas här.",
  "status.reblogs_count": "{count, plural, one {{counter} boost} other {{counter} boostar}}",
  "status.redraft": "Radera & gör om",
  "status.remove_bookmark": "Ta bort bokmärke",
  "status.remove_favourite": "Ta bort från Favoriter",
  "status.remove_quote": "Ta bort",
  "status.replied_in_thread": "Svarade i tråden",
  "status.replied_to": "Svarade på {name}",
  "status.reply": "Svara",
  "status.replyAll": "Svara på tråden",
  "status.report": "Rapportera @{name}",
  "status.request_quote": "Begär att få citera",
  "status.revoke_quote": "Ta bort mitt inlägg från @{name}s inlägg",
  "status.sensitive_warning": "Känsligt innehåll",
  "status.share": "Dela",
  "status.show_less_all": "Visa mindre för alla",
  "status.show_more_all": "Visa mer för alla",
  "status.show_original": "Visa original",
  "status.title.with_attachments": "{user} lade upp {attachmentCount, plural, one {en bilaga} other {{attachmentCount} bilagor}}",
  "status.translate": "Översätt",
  "status.translated_from_with": "Översatt från {lang} med {provider}",
  "status.uncached_media_warning": "Förhandsvisning inte tillgänglig",
  "status.unmute_conversation": "Öppna konversation",
  "status.unpin": "Ångra fäst i profil",
  "subscribed_languages.lead": "Endast inlägg på valda språk kommer att visas på dina hem- och listflöden efter ändringen. Välj ingenting för att se inlägg på alla språk.",
  "subscribed_languages.save": "Spara ändringar",
  "subscribed_languages.target": "Ändra språkprenumerationer för {target}",
  "tabs_bar.home": "Hem",
  "tabs_bar.menu": "Meny",
  "tabs_bar.notifications": "Aviseringar",
  "tabs_bar.publish": "Nytt inlägg",
  "tabs_bar.quick_links": "Snabblänkar",
  "tabs_bar.search": "Sök",
  "tag.remove": "Ta bort",
  "terms_of_service.effective_as_of": "Gäller från och med {date}",
  "terms_of_service.title": "Användarvillkor",
  "terms_of_service.upcoming_changes_on": "Kommande ändringar {date}",
  "time_remaining.days": "{number, plural, one {# dag} other {# dagar}} kvar",
  "time_remaining.hours": "{number, plural, one {# timme} other {# timmar}} kvar",
  "time_remaining.minutes": "{number, plural, one {# minut} other {# minuter}} kvar",
  "time_remaining.moments": "Återstående tillfällen",
  "time_remaining.seconds": "{number, plural, one {# sekund} other {# sekunder}} kvar",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} personer}} under de senaste {days, plural, one {dygnet} other {{days} dagarna}}",
  "trends.trending_now": "Trendar nu",
  "ui.beforeunload": "Ditt utkast kommer att förloras om du lämnar Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Dra & släpp för att ladda upp",
  "upload_button.label": "Lägg till media",
  "upload_error.limit": "Filöverföringsgränsen överskriden.",
  "upload_error.poll": "Filuppladdning tillåts inte med omröstningar.",
  "upload_error.quote": "Filuppladdning tillåts inte med citat.",
  "upload_form.drag_and_drop.instructions": "För att plocka upp en mediebilaga, tryck på mellanslag eller enter. Använd piltangenterna för att flytta mediebilagan. Tryck på mellanslag eller enter igen för att släppa mediebilagan i sin nya position, eller tryck på escape för att avbryta.",
  "upload_form.drag_and_drop.on_drag_cancel": "Flytten avbröts. Mediebilagan {item} släpptes.",
  "upload_form.drag_and_drop.on_drag_end": "Mediebilagan {item} släpptes.",
  "upload_form.drag_and_drop.on_drag_over": "Mediebilagan {item} flyttades.",
  "upload_form.drag_and_drop.on_drag_start": "Mediebilagan {item} plockades upp.",
  "upload_form.edit": "Redigera",
  "upload_progress.label": "Laddar upp...",
  "upload_progress.processing": "Bearbetar…",
  "username.taken": "Det användarnamnet är upptaget. Försök med ett annat",
  "video.close": "Stäng video",
  "video.download": "Ladda ner fil",
  "video.exit_fullscreen": "Stäng helskärm",
  "video.expand": "Expandera video",
  "video.fullscreen": "Helskärm",
  "video.hide": "Dölj video",
  "video.mute": "Tysta",
  "video.pause": "Pausa",
  "video.play": "Spela upp",
  "video.skip_backward": "Hoppa bakåt",
  "video.skip_forward": "Hoppa framåt",
  "video.unmute": "Avtysta",
  "video.volume_down": "Volym ned",
  "video.volume_up": "Volym upp",
  "visibility_modal.button_title": "Ange synlighet",
  "visibility_modal.direct_quote_warning.text": "Om du sparar de nuvarande inställningarna kommer det inbäddade citatet bli konverterat till en länk.",
  "visibility_modal.direct_quote_warning.title": "Citat kan inte bäddas in i privata omnämnanden",
  "visibility_modal.header": "Synlighet och interaktion",
  "visibility_modal.helper.direct_quoting": "Privata omnämnanden som författats på Mastodon kan inte citeras av andra.",
  "visibility_modal.helper.privacy_editing": "Synligheten kan inte ändras efter att ett inlägg är publicerat.",
  "visibility_modal.helper.privacy_private_self_quote": "Självcitat av privata inlägg kan inte göras publika.",
  "visibility_modal.helper.private_quoting": "Inlägg som endast är för följare och som författats på Mastodon kan inte citeras av andra.",
  "visibility_modal.helper.unlisted_quoting": "När folk citerar dig, deras inlägg kommer också att döljas från trendiga tidslinjer.",
  "visibility_modal.instructions": "Styr vem som kan interagera med det här inlägget. Du kan också använda inställningarna för alla framtida inlägg genom att gå till <link>Inställningar > Standardvärden för inlägg</link>.",
  "visibility_modal.privacy_label": "Synlighet",
  "visibility_modal.quote_followers": "Endast följare",
  "visibility_modal.quote_label": "Vem kan citera",
  "visibility_modal.quote_nobody": "Bara jag",
  "visibility_modal.quote_public": "Alla",
  "visibility_modal.save": "Spara"
}
